webpackJsonp([1],{

/***/ 119:
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 119;

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wdApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_rx__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_rx__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


//Nodig om een object om te toveren in een promise.

var wdApi = (function () {
    function wdApi(http) {
        this.http = http;
        this.urlPrefix = window["rootVar"] ? window["rootVar"] : 'http://localhost:65418/api';
        this.jwt = localStorage.getItem('jwt');
    }
    //methods
    wdApi.prototype.setToken = function (token) {
        localStorage.setItem('jwt', token);
        this.jwt = token;
    };
    wdApi.prototype.removeToken = function () {
        localStorage.removeItem('jwt');
        this.jwt = null;
    };
    wdApi.prototype.createAuthorizationHeader = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        if (this.jwt)
            headers.append('Authorization', 'Bearer ' + this.jwt);
        return headers;
    };
    wdApi.prototype.get = function (url) {
        return this.http.get(this.urlPrefix + url, {
            headers: this.createAuthorizationHeader()
        }).catch(this.handleError);
    };
    wdApi.prototype.post = function (url, data) {
        return this.http.post(this.urlPrefix + url, data, {
            headers: this.createAuthorizationHeader()
        }).catch(this.handleError);
    };
    wdApi.prototype.postFile = function (url, file) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var formData = new FormData();
            var xhr = new XMLHttpRequest();
            formData.append("file", file, file.name);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    }
                    else {
                        reject(xhr.response);
                    }
                }
            };
            xhr.open('POST', _this.urlPrefix + url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + _this.jwt);
            xhr.send(formData);
        });
    };
    wdApi.prototype.put = function (url, data) {
        return this.http.put(this.urlPrefix + url, data, {
            headers: this.createAuthorizationHeader()
        }).catch(this.handleError);
    };
    wdApi.prototype.delete = function (url) {
        return this.http.delete(this.urlPrefix + url, {
            headers: this.createAuthorizationHeader()
        }).catch(this.handleError);
    };
    wdApi.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return wdApi;
}());
wdApi = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object])
], wdApi);

var _a;
//# sourceMappingURL=wd.service.js.map

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DictaatConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_rx__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_rx__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var DictaatConfig = (function () {
    function DictaatConfig() {
    }
    return DictaatConfig;
}());

var ConfigService = (function () {
    function ConfigService(http) {
        this.http = http;
        this.Config = new __WEBPACK_IMPORTED_MODULE_2_rxjs_rx__["BehaviorSubject"](null);
        this.DictaatName = new __WEBPACK_IMPORTED_MODULE_2_rxjs_rx__["BehaviorSubject"](null);
    }
    ConfigService.prototype.GetLocalConfig = function () {
        var _this = this;
        this.http.get('dictaat.config.json')
            .subscribe(function (response) {
            _this.Config.next(response.json());
            _this.DictaatName.next(_this.Config.value.name);
        });
        return this.Config;
    };
    ConfigService.prototype.SetLocalConfig = function (config) {
        this.Config.next(config);
        this.DictaatName.next(config.name);
    };
    return ConfigService;
}());
ConfigService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object])
], ConfigService);

var _a;
//# sourceMappingURL=config.service.js.map

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_rx__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(21);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var AccountService = (function () {
    function AccountService(wdapi, router, activatedRoute) {
        this.wdapi = wdapi;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.User = new __WEBPACK_IMPORTED_MODULE_4_rxjs_rx__["BehaviorSubject"](null);
        this.getCurrentUser();
    }
    AccountService.prototype.getCurrentUser = function () {
        var _this = this;
        var user = JSON.parse(localStorage.getItem('user'));
        this.User.next(user);
        this.wdapi.get('/account/current')
            .toPromise()
            .then(function (response) {
            var user = response.json();
            _this.User.next(user);
            localStorage.setItem('user', JSON.stringify(user));
        })
            .catch(function (err) {
            _this.User.next(null);
            localStorage.setItem('user', null);
        });
    };
    AccountService.prototype.SetToken = function (token) {
        this.wdapi.setToken(token);
        this.getCurrentUser();
    };
    AccountService.prototype.Login = function () {
        //retrieve the host url including subfolders this app is runing in.
        var baseUrl = window.location.toString().split('#')[0];
        window.location.href = this.wdapi.urlPrefix + "/account/AvansLogin?returnurl=" + baseUrl;
    };
    AccountService.prototype.Logoff = function () {
        //redrict to home after logout
        this.wdapi.removeToken();
        localStorage.removeItem('user');
        window.location.href = this.wdapi.urlPrefix + "/account/LogOff?returnurl=" + window.location;
    };
    return AccountService;
}());
AccountService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* ActivatedRoute */]) === "function" && _c || Object])
], AccountService);

var _a, _b, _c;
//# sourceMappingURL=account.service.js.map

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleAnalyticsEventsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var GoogleAnalyticsEventsService = (function () {
    function GoogleAnalyticsEventsService() {
        this.InitializeGa(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    }
    GoogleAnalyticsEventsService.prototype.emitEvent = function (eventCategory, eventAction, eventLabel, eventValue) {
        if (eventLabel === void 0) { eventLabel = null; }
        if (eventValue === void 0) { eventValue = null; }
        ga('send', 'event', {
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            eventValue: eventValue
        });
    };
    //Code snippet from GA docs
    GoogleAnalyticsEventsService.prototype.InitializeGa = function (i, s, o, g, r, a, m) {
        if (a === void 0) { a = null; }
        if (m === void 0) { m = null; }
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = (1 * (new Date()));
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        a.onload = function () {
            ga('create', 'UA-113126593-1', 'auto');
        };
        m.parentNode.insertBefore(a, m);
    };
    GoogleAnalyticsEventsService.prototype.send = function () {
        ga('send', 'pageview');
    };
    GoogleAnalyticsEventsService.prototype.set = function (url) {
        ga('set', 'page', url);
    };
    return GoogleAnalyticsEventsService;
}());
GoogleAnalyticsEventsService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [])
], GoogleAnalyticsEventsService);

//# sourceMappingURL=google-analytics.service.js.map

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_service__ = __webpack_require__(446);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PageComponent = (function () {
    function PageComponent(route, pageService) {
        this.route = route;
        this.pageService = pageService;
    }
    PageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.forEach(function (params) {
            var name = params['pageName'];
            _this.pageService.getPage(name)
                .then(function (page) {
                _this.page = page;
            });
        });
    };
    PageComponent.prototype.enableExternalLibraries = function () {
        if (window.Prism) {
            window.Prism.highlightAll();
        }
    };
    return PageComponent;
}());
PageComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-page",
        template: "\n    <div *ngIf=\"page\">\n        <html-outlet [html]=\"page\" (afterCompile)=\"enableExternalLibraries()\"></html-outlet>\n    </div>\n",
        providers: [__WEBPACK_IMPORTED_MODULE_2__page_service__["a" /* PageService */]]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__page_service__["a" /* PageService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__page_service__["a" /* PageService */]) === "function" && _b || Object])
], PageComponent);

var _a, _b;
//# sourceMappingURL=page.component.js.map

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTokenComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_account_service__ = __webpack_require__(19);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ProcessTokenComponent = (function () {
    function ProcessTokenComponent(activatedRoute, accountService, router) {
        this.activatedRoute = activatedRoute;
        this.accountService = accountService;
        this.router = router;
    }
    ProcessTokenComponent.prototype.ngOnInit = function () {
        var _this = this;
        // subscribe to router event
        this.activatedRoute.queryParams.subscribe(function (params) {
            var token = params['token'];
            _this.accountService.SetToken(token);
            _this.router.navigateByUrl('/');
        });
    };
    return ProcessTokenComponent;
}());
ProcessTokenComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-process-token",
        template: "\n    <div class=\"container-fluid\">\n        <p > Logging in...</p>\n    </div>\n",
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */]) === "function" && _c || Object])
], ProcessTokenComponent);

var _a, _b, _c;
//# sourceMappingURL=process-token.component.js.map

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_participantService__ = __webpack_require__(92);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var ProfileComponent = (function () {
    function ProfileComponent(dictaatService, participantService, accountService, configService) {
        this.dictaatService = dictaatService;
        this.participantService = participantService;
        this.accountService = accountService;
        this.configService = configService;
    }
    ProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.User.subscribe(function (user) {
            _this.user = user;
            _this.retrieveData();
        });
        this.configService.Config.subscribe(function (config) {
            if (!config)
                return;
            _this.dictaatName = config.name;
            _this.retrieveData();
        });
    };
    ProfileComponent.prototype.retrieveData = function () {
        var _this = this;
        if (!this.dictaatName || !this.user)
            return;
        this.dictaatService.getGroups(this.dictaatName).then(function (groups) {
            _this.groups = groups;
            _this.groups.push({ groupName: "none" });
        });
        this.participantService.getParticipant(this.dictaatName, this.user.email).then(function (participant) {
            _this.participant = participant;
            _this.group = participant.group;
        });
    };
    ProfileComponent.prototype.join = function (groupName) {
        var _this = this;
        this.isSwitching = true;
        this.dictaatService.join(this.dictaatName, this.group)
            .then(function (didJoin) {
            _this.participant.group = groupName;
            _this.isSwitching = false;
        });
    };
    ProfileComponent.prototype.switchGroup = function (groupName) {
        var _this = this;
        this.isSwitching = true;
        this.dictaatService.switchGroup(this.dictaatName, this.group)
            .subscribe(function (didJoin) {
            _this.participant.group = groupName;
            _this.isSwitching = false;
        });
    };
    return ProfileComponent;
}());
ProfileComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-profile',
        template: __webpack_require__(448),
        styles: [__webpack_require__(449)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__["a" /* DictaatService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__["a" /* DictaatService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4__shared_services_participantService__["a" /* ParticipantService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__shared_services_participantService__["a" /* ParticipantService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__["a" /* AccountService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3__shared_services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__shared_services_config_service__["a" /* ConfigService */]) === "function" && _d || Object])
], ProfileComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=profile.component.js.map

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_basemodal_service__ = __webpack_require__(36);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var RatingService = (function (_super) {
    __extends(RatingService, _super);
    function RatingService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    RatingService.prototype.addRating = function (dictaatName, rating) {
        var _this = this;
        var url = "/dictaten/" + dictaatName + '/rating';
        return this.wdapi.post(url, rating)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function () {
            _this.resolveCancel(); //hier nog niet bij mee
            _this.handleError;
            return null;
        });
    };
    RatingService.prototype.SendRate = function (dictaatName, ratingId, rate) {
        var _this = this;
        var url = "/dictaten/" + dictaatName + '/rating/' + ratingId + '/rates';
        return this.wdapi.post(url, rate)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function () {
            _this.resolveCancel(); //hier nog niet bij mee
            _this.handleError;
            return null;
        });
    };
    RatingService.prototype.getRating = function (dictaatName, ratingId) {
        if (!ratingId) {
            return new Promise(function (resolve, reject) {
                reject("Cannot load rating without ratingId");
            });
        }
        var url = "/dictaten/" + dictaatName + '/rating/' + ratingId;
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    RatingService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return RatingService;
}(__WEBPACK_IMPORTED_MODULE_4__core_basemodal_service__["a" /* BaseModalService */]));
RatingService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], RatingService);

var _a;
//# sourceMappingURL=rating.service.js.map

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AchievementService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AchievementService = (function () {
    function AchievementService(wdapi) {
        this.wdapi = wdapi;
    }
    AchievementService.prototype.getDictaatAchievements = function (dictaatName) {
        var url = "/dictaten/" + dictaatName + "/Achievement";
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AchievementService.prototype.getUserAchievements = function (dictaatName, userid) {
        var url = "/dictaten/" + dictaatName + "/Achievement/" + userid;
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AchievementService.prototype.AddUserAchievement = function (dictaatName, achievid, userid) {
        var url = "/dictaten/" + dictaatName + "/Achievement/" + achievid + "/user/" + userid;
        return this.wdapi.post(url, { userId: userid })
            .toPromise()
            .then(function (response) {
            console.log(response);
        });
    };
    AchievementService.prototype.DeleteUserAchievement = function (dictaatName, achievid, userid) {
        var url = "/dictaten/" + dictaatName + "/Achievement/" + achievid + "/user/" + userid;
        return this.wdapi.delete(url)
            .toPromise()
            .then(function (response) {
            console.log(response);
        });
    };
    return AchievementService;
}());
AchievementService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], AchievementService);

var _a;
//# sourceMappingURL=achievement.service.js.map

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuizComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_quiz_service__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__ = __webpack_require__(279);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var QuizComponent = (function () {
    function QuizComponent(configService, accountService, quizService, route) {
        this.configService = configService;
        this.accountService = accountService;
        this.quizService = quizService;
        this.route = route;
        this.limit = false;
    }
    QuizComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.quiz = this.quizService.getTemporary(this.qid);
        this.accountService.User.subscribe(function (user) { _this.isAuth = user != null; });
        this.configService.DictaatName.subscribe(function (name) {
            _this.dictaatName = name;
            if (!_this.quiz) {
                _this.isLoading = true;
                _this.refreshQuiz();
            }
        });
    };
    QuizComponent.prototype.refreshQuiz = function () {
        var _this = this;
        this.quizService.getQuiz(this.dictaatName, this.qid)
            .then(function (q) {
            _this.quiz = q;
            _this.isLoading = false;
        })
            .catch(function (error) {
            _this.isLoading = false;
        });
    };
    QuizComponent.prototype.edit = function () {
        var _this = this;
        var original = Object.assign({}, this.quiz);
        this.quizService.ShowModal('edit', [this.quiz])
            .then(function (quiz) { return _this.refreshQuiz(); })
            .catch(function () {
            _this.quiz = new __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__["a" /* Quiz */](original);
        });
    };
    QuizComponent.prototype.start = function () {
        this.quiz.start();
    };
    QuizComponent.prototype.continue = function () {
        this.quiz.nextQuestion();
        this.quizService.saveTemporary(this.quiz);
        if (this.quiz.status == 'finished') {
            this.submit();
        }
    };
    QuizComponent.prototype.submit = function () {
        var _this = this;
        this.isSubmitting = true;
        var attempt = [];
        this.quiz.questions.forEach(function (q) {
            attempt.push({
                questionId: q.id,
                isCorrect: q.isCorrect
            });
        });
        this.quizService.submitAnswers(this.dictaatName, this.quiz.id, attempt)
            .then(function (quiz) {
            _this.quiz = quiz;
            _this.isSubmitting = false;
            _this.quizService.deleteTemporary(_this.quiz.id);
        });
    };
    QuizComponent.prototype.retakeQuiz = function () {
        this.start();
    };
    QuizComponent.prototype.login = function () {
        this.accountService.Login();
    };
    return QuizComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], QuizComponent.prototype, "qid", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Boolean)
], QuizComponent.prototype, "limit", void 0);
QuizComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-quiz',
        template: __webpack_require__(459),
        styles: [__webpack_require__(460)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__services_config_service__["a" /* ConfigService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__services_quiz_service__["a" /* QuizService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_quiz_service__["a" /* QuizService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */]) === "function" && _d || Object])
], QuizComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=quiz.component.js.map

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuizService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__ = __webpack_require__(279);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var QuizService = (function (_super) {
    __extends(QuizService, _super);
    function QuizService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    QuizService.prototype.saveTemporary = function (quiz) {
        var copy = Object.assign({}, quiz);
        copy.status = "temporary";
        localStorage.setItem("quiz:" + copy.id, JSON.stringify(copy));
    };
    QuizService.prototype.getTemporary = function (qid) {
        var storage = localStorage.getItem("quiz:" + qid);
        var quiz = storage ? JSON.parse(storage) : null;
        return quiz ? new __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__["a" /* Quiz */](quiz) : null;
    };
    QuizService.prototype.deleteTemporary = function (qid) {
        localStorage.removeItem("quiz:" + qid);
    };
    QuizService.prototype.getQuizes = function (dictaatName) {
        var url = "/dictaten/" + dictaatName + '/quiz';
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    QuizService.prototype.update = function (dictaatName, quiz) {
        var url = "/dictaten/" + dictaatName + '/quiz/' + quiz.id;
        return this.wdapi.put(url, quiz)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    QuizService.prototype.addQuiz = function (dictaatName, quiz) {
        var _this = this;
        var url = "/dictaten/" + dictaatName + '/quiz';
        return this.wdapi.post(url, quiz)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function () {
            _this.resolveCancel(); //hier nog niet bij mee
            return null;
        });
    };
    QuizService.prototype.getQuiz = function (dictaatName, quizId) {
        if (!quizId) {
            return new Promise(function (resolve, reject) {
                reject("Cannot load quiz without quizId");
            });
        }
        var url = "/dictaten/" + dictaatName + '/quiz/' + quizId;
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return new __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__["a" /* Quiz */](response.json());
        });
    };
    QuizService.prototype.submitAnswers = function (dictaatName, quizId, givenAnswers) {
        var url = "/dictaten/" + dictaatName + '/quiz/' + quizId + '/attempts';
        return this.wdapi.post(url, givenAnswers)
            .toPromise()
            .then(function (response) { return new __WEBPACK_IMPORTED_MODULE_5__models_quiz_quiz__["a" /* Quiz */](response.json()); });
    };
    QuizService.prototype.removeQuestion = function (dictaatName, quizId, question) {
        var url = "/dictaten/" + dictaatName + '/quiz/' + quizId + '/questions/' + question.id;
        return this.wdapi.delete(url)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    QuizService.prototype.updateQuestion = function (dictaatName, quizId, question) {
        var url = "/dictaten/" + dictaatName + '/quiz/' + quizId + '/questions/' + question.id;
        return this.wdapi.put(url, question)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    return QuizService;
}(__WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__["a" /* BaseModalService */]));
QuizService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], QuizService);

var _a;
//# sourceMappingURL=quiz.service.js.map

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Quiz; });
/* unused harmony export QuizSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__question__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignment__ = __webpack_require__(67);


var Quiz = (function () {
    function Quiz(json) {
        if (json === void 0) { json = null; }
        var _this = this;
        this.questions = [];
        this.currentIndex = 0;
        this.assignment = new __WEBPACK_IMPORTED_MODULE_1__assignment__["a" /* Assignment */]();
        if (json) {
            this.id = json.id;
            this.dictaat = json.dictaat;
            this.shuffle = json.shuffle;
            this.isComplete = json.isComplete;
            this.currentIndex = json.currentIndex;
            this.current = this.questions[this.currentIndex];
            //map assignment
            this.assignment = new __WEBPACK_IMPORTED_MODULE_1__assignment__["a" /* Assignment */](json.assignment);
            //map questions
            json.questions.forEach(function (q) {
                _this.questions.push(new __WEBPACK_IMPORTED_MODULE_0__question__["a" /* Question */](q));
            });
            this.current = this.questions[this.currentIndex];
            this.myAttempts = json.myAttempts ? json.myAttempts : [];
            if (this.myAttempts && this.myAttempts.length > 0) {
                this.status = "finished";
                this.lastAttempt = this.myAttempts[0];
            }
            else {
                this.status = 'idle';
            }
            this.status = json.status ? json.status : this.status;
        }
    }
    Quiz.prototype.start = function () {
        this.currentIndex = 0;
        this.status = "started";
        this.current = this.questions[this.currentIndex];
    };
    Quiz.prototype.isValid = function () {
        if (!this.assignment.isValid())
            return false;
        if (this.questions.length == 0)
            return false;
        var response = true;
        this.questions.forEach(function (question) {
            if (!question.isValid()) {
                response = false;
            }
        });
        return response;
    };
    Quiz.prototype.nextQuestion = function () {
        this.currentIndex++;
        if (this.questions.length == this.currentIndex) {
            this.status = 'finished';
        }
        else {
            this.current = this.questions[this.currentIndex];
        }
    };
    Quiz.prototype.getLastAttempt = function () {
        if (this.myAttempts && this.myAttempts.length > 0)
            return this.myAttempts[0];
        else
            return null;
    };
    return Quiz;
}());

var QuizSummary = (function () {
    function QuizSummary() {
    }
    return QuizSummary;
}());

//# sourceMappingURL=quiz.js.map

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavMenuService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_wd_service__ = __webpack_require__(17);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var NavMenuService = (function () {
    function NavMenuService(http, router, api) {
        this.http = http;
        this.router = router;
        this.api = api;
    }
    NavMenuService.prototype.getLocalNavMenu = function () {
        var _this = this;
        if (this.menuItems != null) {
            return Promise.resolve(this.menuItems);
        }
        else {
            return this.http.get('nav-menu.json?v=' + new Date().getTime())
                .toPromise()
                .then(function (response) {
                return _this.menuItems = response.json();
            }).catch(this.handleError);
        }
    };
    NavMenuService.prototype.updateNavMenu = function (dictaatName, menuItems) {
        var resource = "/dictaten/" + dictaatName + "/menu";
        return this.api.put(resource, menuItems)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    NavMenuService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return NavMenuService;
}());
NavMenuService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* Router */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__core_wd_service__["a" /* wdApi */]) === "function" && _c || Object])
], NavMenuService);

var _a, _b, _c;
//# sourceMappingURL=nav-menu.service.js.map

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PollService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_poll__ = __webpack_require__(282);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var PollService = (function (_super) {
    __extends(PollService, _super);
    function PollService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    PollService.prototype.vote = function (dictaatName, pollId, optionId) {
        var url = "/dictaten/" + dictaatName + '/poll/' + pollId + '/options/' + optionId + '/votes';
        return this.wdapi.post(url, {})
            .map(function (res) { return new __WEBPACK_IMPORTED_MODULE_5__models_poll__["a" /* Poll */](res.json()); })
            .toPromise();
    };
    PollService.prototype.updatePoll = function (dictaatName, poll) {
        var _this = this;
        var url = "/dictaten/" + dictaatName + '/poll/' + poll.id;
        ;
        return this.wdapi.put(url, poll)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function () {
            _this.resolveCancel(); //hier nog niet blij mee
            return null;
        });
    };
    PollService.prototype.addPoll = function (dictaatName, poll) {
        var _this = this;
        var url = "/dictaten/" + dictaatName + '/poll/';
        ;
        return this.wdapi.post(url, poll)
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function () {
            _this.resolveCancel(); //hier nog niet blij mee
            return null;
        });
    };
    PollService.prototype.getPolls = function (dictaatName) {
        var url = "/dictaten/" + dictaatName + '/poll/';
        ;
        return this.wdapi.get(url)
            .map(function (res) { return res.json(); })
            .toPromise();
    };
    PollService.prototype.getPoll = function (dictaatName, pollId) {
        if (!pollId) {
            return new Promise(function (resolve, reject) {
                reject("Cannot load poll without pollId");
            });
        }
        var url = "/dictaten/" + dictaatName + '/poll/' + pollId;
        return this.wdapi.get(url)
            .map(function (res) { return new __WEBPACK_IMPORTED_MODULE_5__models_poll__["a" /* Poll */](res.json()); })
            .toPromise();
    };
    return PollService;
}(__WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__["a" /* BaseModalService */]));
PollService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], PollService);

var _a;
//# sourceMappingURL=poll.service.js.map

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Poll; });
var Poll = (function () {
    function Poll(json) {
        if (json === void 0) { json = null; }
        this.options = [{}, {}];
        if (json) {
            this.id = json.id;
            this.options = json.options;
            this.question = json.question;
            this.myVote = json.myVote;
        }
    }
    Poll.prototype.isValid = function () {
        var isValid = this.question != null && this.options.length >= 2;
        this.options.forEach(function (o) {
            if (o.text == null)
                isValid = false;
        });
        return isValid;
    };
    return Poll;
}());

//# sourceMappingURL=poll.js.map

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LeaderboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_config_service__ = __webpack_require__(18);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var LeaderboardComponent = (function () {
    function LeaderboardComponent(dictaatService, accountService, configService) {
        this.dictaatService = dictaatService;
        this.accountService = accountService;
        this.configService = configService;
        this.state = 1;
        this.tab = 'individual';
        this.sort = 'average';
    }
    LeaderboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        //handle inputs
        this.state = this.tab == 'group' ? 0 : 1;
        this.user = this.accountService.User;
        this.configService.Config.subscribe(function (config) {
            if (config) {
                //load individual
                _this.dictaatService.getParticipants(config.name)
                    .then(function (participants) {
                    _this.participants = participants;
                    _this.top5 = participants.slice(0, 5);
                    _this.leaderboard = _this.top5;
                });
                //load groups
                _this.dictaatService.getGroups(config.name)
                    .then(function (groups) {
                    _this.groups = groups.sort(function (a, b) {
                        if (_this.sort == 'total')
                            return a.totalPoints < b.totalPoints ? 1 : -1;
                        else
                            return a.points < b.points ? 1 : -1;
                    });
                });
            }
        });
    };
    return LeaderboardComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", String)
], LeaderboardComponent.prototype, "tab", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", String)
], LeaderboardComponent.prototype, "sort", void 0);
LeaderboardComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-leaderboard',
        template: __webpack_require__(490),
        styles: [__webpack_require__(491)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__services_dictaat_service__["a" /* DictaatService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_dictaat_service__["a" /* DictaatService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_config_service__["a" /* ConfigService */]) === "function" && _c || Object])
], LeaderboardComponent);

var _a, _b, _c;
//# sourceMappingURL=leaderboard.component.js.map

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatabModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datab_component__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datab_service__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_game_elements_game_elements_module__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_wd_shared_module__ = __webpack_require__(44);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var DatabModule = (function () {
    function DatabModule() {
    }
    return DatabModule;
}());
DatabModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        imports: [
            __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_4__angular_http__["c" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* FormsModule */], __WEBPACK_IMPORTED_MODULE_6__shared_game_elements_game_elements_module__["a" /* GameElementsModule */], __WEBPACK_IMPORTED_MODULE_7__shared_wd_shared_module__["a" /* WdSharedModule */]
        ],
        declarations: [
            __WEBPACK_IMPORTED_MODULE_1__datab_component__["a" /* DatabComponent */],
        ],
        exports: [
            __WEBPACK_IMPORTED_MODULE_1__datab_component__["a" /* DatabComponent */]
        ],
        providers: [
            __WEBPACK_IMPORTED_MODULE_2__datab_service__["a" /* DatabService */]
        ],
    })
], DatabModule);

//# sourceMappingURL=datab.module.js.map

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DbAssignment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DbSubmission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatabService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_models_assignment__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var DbAssignment = (function (_super) {
    __extends(DbAssignment, _super);
    function DbAssignment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DbAssignment;
}(__WEBPACK_IMPORTED_MODULE_5__shared_models_assignment__["a" /* Assignment */]));

var DbSubmission = (function () {
    function DbSubmission() {
    }
    return DbSubmission;
}());

var DatabService = (function () {
    //private root = "https://localhost:22608"
    function DatabService(http, wdApi) {
        this.http = http;
        this.wdApi = wdApi;
        this.root = "https://webdictaat.aii.avans.nl/apis/databases";
    }
    DatabService.prototype.getAssignment = function (daid) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"](function (o) {
            //return data from local
            var cache = _this.getFromLocal('a', daid);
            if (cache)
                return o.next(cache);
            //if no cache then retreive from online
            _this.http.get(_this.root + "/assignments/" + daid)
                .map(function (response) { return response.json(); })
                .do(function (a) { return _this.saveAssignmentInLocal(a); })
                .subscribe(function (a) { return o.next(a); });
        });
    };
    DatabService.prototype.getSubmissions = function (daid, userId) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"](function (o) {
            //return data from local
            var cache = _this.getFromLocal('s', daid);
            if (cache)
                return o.next(cache);
            //if no cache then retreive from online
            _this.http.get(_this.root + "/assignments/" + daid + "/submissions/" + userId)
                .map(function (response) { return response.json(); })
                .do(function (s) { return _this.saveSubmissionInLocal(s); })
                .subscribe(function (s) { return o.next(s); });
        });
    };
    DatabService.prototype.sendSubmission = function (waid, daid, submission) {
        var _this = this;
        submission.originalAssignmentId = waid;
        return this.http.post(this.root + "/assignments/" + daid + "/submissions", submission)
            .map(function (response) { return response.json(); })
            .do(function (s) { return _this.saveSubmissionInLocal(s); });
    };
    DatabService.prototype.getFromLocal = function (type, id) {
        return JSON.parse(localStorage.getItem('databaas:' + +type + ':' + id));
    };
    DatabService.prototype.saveAssignmentInLocal = function (assignment) {
        localStorage.setItem('databaas:a:' + assignment.assignmentId, JSON.stringify(assignment));
    };
    DatabService.prototype.saveSubmissionInLocal = function (submission) {
        if (!submission)
            return;
        localStorage.setItem('databaas:s:' + submission.assignmentId, JSON.stringify(submission));
    };
    return DatabService;
}());
DatabService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__["a" /* wdApi */]) === "function" && _b || Object])
], DatabService);

var _a, _b;
//# sourceMappingURL=datab.service.js.map

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(299);


/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_client_app_module__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environments_environment__ = __webpack_require__(514);




if (__WEBPACK_IMPORTED_MODULE_3__environments_environment__["a" /* environment */].production) {
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_23" /* enableProdMode */])();
}
Object(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_2__app_client_app_module__["a" /* ClientModule */]);
//# sourceMappingURL=main.client.js.map

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser_animations__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_component__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_routing__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_page_page_component__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_core_html_outlet_directive__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_nav_menu_nav_menu_component__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_avatar_avatar_component__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_wd_shared_module__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__extern_databases_datab_module__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_game_elements_game_elements_module__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__message_message_component__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__profile_profile_component__ = __webpack_require__(274);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






//components






//modules





var ClientModule = (function () {
    function ClientModule() {
    }
    return ClientModule;
}());
ClientModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* FormsModule */], __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */], __WEBPACK_IMPORTED_MODULE_12__shared_wd_shared_module__["a" /* WdSharedModule */], __WEBPACK_IMPORTED_MODULE_3__angular_http__["c" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_7__app_routing__["a" /* routing */], __WEBPACK_IMPORTED_MODULE_13__extern_databases_datab_module__["a" /* DatabModule */], __WEBPACK_IMPORTED_MODULE_14__shared_game_elements_game_elements_module__["a" /* GameElementsModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_9__shared_core_html_outlet_directive__["a" /* HtmlOutlet */], __WEBPACK_IMPORTED_MODULE_6__app_component__["a" /* AppComponent */], __WEBPACK_IMPORTED_MODULE_8__shared_page_page_component__["a" /* PageComponent */], __WEBPACK_IMPORTED_MODULE_10__shared_nav_menu_nav_menu_component__["a" /* NavMenuComponent */], __WEBPACK_IMPORTED_MODULE_11__shared_avatar_avatar_component__["a" /* AvatarComponent */], __WEBPACK_IMPORTED_MODULE_15__message_message_component__["a" /* MessageComponent */], __WEBPACK_IMPORTED_MODULE_16__profile_profile_component__["a" /* ProfileComponent */]],
        providers: [
            { provide: __WEBPACK_IMPORTED_MODULE_4__angular_common__["g" /* LocationStrategy */], useClass: __WEBPACK_IMPORTED_MODULE_4__angular_common__["d" /* HashLocationStrategy */] }
        ],
        bootstrap: [__WEBPACK_IMPORTED_MODULE_6__app_component__["a" /* AppComponent */]]
    })
], ClientModule);

//# sourceMappingURL=app.module.js.map

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_google_analytics_service__ = __webpack_require__(271);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var ga;
var AppComponent = (function () {
    function AppComponent(router, configService, ga) {
        this.router = router;
        this.configService = configService;
        this.ga = ga;
        this.Title = "Webdictaat";
        this.showSidebar = false;
        this.unhandledRouteEvents = [];
    }
    AppComponent.prototype.sendNewRouteEvent = function (url) {
        var _this = this;
        this.unhandledRouteEvents.push(url);
        if (this.Title) {
            this.unhandledRouteEvents.forEach(function (url) {
                _this.ga.set(_this.Title + '/#' + url);
                _this.ga.send();
            });
        }
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configService.DictaatName.subscribe(function (dictaatName) { return _this.Title = dictaatName; });
        this.router.events.subscribe(function (event) {
            _this.showSidebar = false;
            if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["b" /* NavigationEnd */]) {
                window.scrollTo(0, 0);
                _this.sendNewRouteEvent(event.urlAfterRedirects);
            }
        });
        //get the local config once
        this.configService.GetLocalConfig();
    };
    return AppComponent;
}());
AppComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-client-app",
        template: __webpack_require__(443),
        styles: [__webpack_require__(444)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* Router */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__["a" /* ConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__shared_services_google_analytics_service__["a" /* GoogleAnalyticsEventsService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__shared_services_google_analytics_service__["a" /* GoogleAnalyticsEventsService */]) === "function" && _c || Object])
], AppComponent);

var _a, _b, _c;
//# sourceMappingURL=app.component.js.map

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseModalService; });
/* unused harmony export BaseModalComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

//Nodig om een object om te toveren in een promise.



var ModalEvent = (function () {
    function ModalEvent() {
    }
    return ModalEvent;
}());
var ShowModalEvent = (function (_super) {
    __extends(ShowModalEvent, _super);
    function ShowModalEvent(modalType, params) {
        var _this = _super.call(this) || this;
        _this.modalType = modalType;
        _this.params = params;
        _this.isVisible = true;
        return _this;
    }
    return ShowModalEvent;
}(ModalEvent));
var CancelModalEvent = (function (_super) {
    __extends(CancelModalEvent, _super);
    function CancelModalEvent() {
        var _this = _super.call(this) || this;
        _this.params = null;
        _this.isVisible = false;
        return _this;
    }
    return CancelModalEvent;
}(ModalEvent));
var BaseModalService = (function () {
    function BaseModalService() {
        this.modalEvent = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
    }
    BaseModalService.prototype.ShowModal = function (modal, params) {
        var _this = this;
        this.modalEvent.next(new ShowModalEvent(modal, params));
        return new Promise(function (resolve, reject) {
            _this.resolveComplete = resolve;
            _this.resolveCancel = reject;
        });
    };
    BaseModalService.prototype.CancelModal = function () {
        this.resolveCancel();
        this.modalEvent.next(new CancelModalEvent());
    };
    BaseModalService.prototype.CompleteModal = function (objectToResolve) {
        this.resolveComplete(objectToResolve);
        this.modalEvent.next(new CancelModalEvent());
    };
    return BaseModalService;
}());
BaseModalService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [])
], BaseModalService);

var BaseModalComponent = (function () {
    function BaseModalComponent() {
    }
    ///call this method to initialize base component
    BaseModalComponent.prototype.wdOnInit = function (service, zone) {
        var _this = this;
        this.baseService = service;
        service.modalEvent.subscribe(function (modalEvent) {
            _this.isModalVisible = modalEvent.isVisible;
            _this.modalType = modalEvent.modalType;
            _this.params = modalEvent.params;
            zone.run(function () { });
        });
    };
    BaseModalComponent.prototype.cancel = function () {
        this.baseService.CancelModal();
    };
    return BaseModalComponent;
}());

//# sourceMappingURL=basemodal.service.js.map

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DictaatService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_dictaat__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_service__ = __webpack_require__(18);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

//Nodig om een object om te toveren in een promise.







var DictaatService = (function () {
    function DictaatService(wdapi, route, router, config) {
        this.wdapi = wdapi;
        this.route = route;
        this.router = router;
        this.config = config;
        this.CurrentDictaat = new __WEBPACK_IMPORTED_MODULE_6_rxjs_BehaviorSubject__["BehaviorSubject"](null);
    }
    DictaatService.prototype.getDictaat = function (dictaatName) {
        var _this = this;
        return this.wdapi.get("/dictaten/" + dictaatName)
            .map(function (response) { return new __WEBPACK_IMPORTED_MODULE_1__models_dictaat__["a" /* Dictaat */](response.json()); })
            .toPromise()
            .then(function (dictaat) {
            if (dictaat) {
                _this.CurrentDictaat.next(dictaat);
                return dictaat;
            }
        });
    };
    DictaatService.prototype.removeDictaat = function (dictaatName) {
        return this.wdapi.delete("/dictaten/" + dictaatName)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    DictaatService.prototype.addDictaat = function (dictaatName) {
        return this.wdapi.post('/dictaten', { name: dictaatName })
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    DictaatService.prototype.copyDictaat = function (dictaatName, newDictaatName) {
        return this.wdapi.post('/dictaten/' + dictaatName + '/copies', { name: newDictaatName })
            .map(function (response) { return response.json(); })
            .toPromise();
    };
    DictaatService.prototype.getDictaatSession = function (dictaatName) {
        return this.wdapi.get("/dictaten/" + dictaatName + '/sessions/current')
            .map(function (response) { return response.json(); });
    };
    DictaatService.prototype.getDictaatContributers = function (dictaatName) {
        return this.wdapi.get("/dictaten/" + dictaatName + '/contributers')
            .map(function (response) { return response.json(); })
            .toPromise();
    };
    DictaatService.prototype.join = function (dictaatName, group) {
        return this.wdapi.post('/dictaten/' + dictaatName + '/groups/' + group, {})
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    DictaatService.prototype.switchGroup = function (dictaatName, group) {
        return this.wdapi.put('/dictaten/' + dictaatName + '/groups/' + group, {})
            .map(function (response) { return response.json(); });
    };
    DictaatService.prototype.addContributer = function (dictaatName, email) {
        return this.wdapi.post('/dictaten/' + dictaatName + '/contributers/', { 'email': email })
            .map(function (response) { return response.json(); })
            .toPromise();
    };
    DictaatService.prototype.getDictaten = function () {
        return this.wdapi.get('/dictaten')
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    DictaatService.prototype.getMarkings = function (name) {
        return this.wdapi.get('/dictaten/' + name + '/markings')
            .toPromise()
            .then(function (response) {
            return new __WEBPACK_IMPORTED_MODULE_1__models_dictaat__["b" /* DictaatMarkings */](response.json());
        });
    };
    DictaatService.prototype.getParticipants = function (dictaatName) {
        return this.wdapi.get('/dictaten/' + dictaatName + '/participants')
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    DictaatService.prototype.getGroups = function (dictaatName) {
        return this.wdapi.get('/dictaten/' + dictaatName + '/groups')
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    DictaatService.prototype.addGroups = function (dictaatName, groups) {
        return this.wdapi.post('/dictaten/' + dictaatName + '/groups', groups)
            .map(function (response) { return response.json(); });
    };
    DictaatService.prototype.removeGroup = function (dictaatName, groupName) {
        return this.wdapi.delete('/dictaten/' + dictaatName + '/groups/' + groupName)
            .map(function (response) { return response.json(); });
    };
    return DictaatService;
}());
DictaatService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* ActivatedRoute */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__angular_router__["c" /* Router */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_7__config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__config_service__["a" /* ConfigService */]) === "function" && _d || Object])
], DictaatService);

var _a, _b, _c, _d;
//# sourceMappingURL=dictaat.service.js.map

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WdSharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_dialog_service__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_rating_service__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_images_service__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_security_dirty_guard__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_video_service__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nav_menu_nav_menu_service__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_achievement_service__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_quiz_service__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_assignment_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_participantService__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__spinner_spinner_component__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__core_wdfilter_pipe__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__core_group_by_pipe__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__core_order_by_pipe__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__core_process_token_component__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_styling_service__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modal_component_modal_component_component__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__services_google_analytics_service__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_poll_service__ = __webpack_require__(281);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



//shared services
 //the service for config variables












//shared components









/**
 * This mdule contains all the shared services, and components that are reusable across the application
 */
var WdSharedModule = (function () {
    function WdSharedModule() {
    }
    return WdSharedModule;
}());
WdSharedModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */]],
        providers: [
            __WEBPACK_IMPORTED_MODULE_4__services_dialog_service__["a" /* DialogService */], __WEBPACK_IMPORTED_MODULE_12__services_quiz_service__["a" /* QuizService */], __WEBPACK_IMPORTED_MODULE_6__services_images_service__["a" /* ImageService */], __WEBPACK_IMPORTED_MODULE_11__services_achievement_service__["a" /* AchievementService */], __WEBPACK_IMPORTED_MODULE_7__services_account_service__["a" /* AccountService */], __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */], __WEBPACK_IMPORTED_MODULE_3__services_config_service__["a" /* ConfigService */],
            __WEBPACK_IMPORTED_MODULE_5__services_rating_service__["a" /* RatingService */], __WEBPACK_IMPORTED_MODULE_8__core_security_dirty_guard__["a" /* DirtyGuard */], __WEBPACK_IMPORTED_MODULE_9__services_video_service__["a" /* VideoService */], __WEBPACK_IMPORTED_MODULE_10__nav_menu_nav_menu_service__["a" /* NavMenuService */], __WEBPACK_IMPORTED_MODULE_13__services_assignment_service__["a" /* AssignmentService */], __WEBPACK_IMPORTED_MODULE_14__services_dictaat_service__["a" /* DictaatService */], __WEBPACK_IMPORTED_MODULE_15__services_participantService__["a" /* ParticipantService */],
            __WEBPACK_IMPORTED_MODULE_21__services_styling_service__["a" /* StylingService */], __WEBPACK_IMPORTED_MODULE_23__services_google_analytics_service__["a" /* GoogleAnalyticsEventsService */], __WEBPACK_IMPORTED_MODULE_24__services_poll_service__["a" /* PollService */]
        ],
        declarations: [__WEBPACK_IMPORTED_MODULE_16__spinner_spinner_component__["a" /* SpinnerComponent */], __WEBPACK_IMPORTED_MODULE_17__core_wdfilter_pipe__["a" /* WdFilterPipe */], __WEBPACK_IMPORTED_MODULE_18__core_group_by_pipe__["a" /* GroupByPipe */], __WEBPACK_IMPORTED_MODULE_19__core_order_by_pipe__["a" /* ArraySortPipe */], __WEBPACK_IMPORTED_MODULE_20__core_process_token_component__["a" /* ProcessTokenComponent */], __WEBPACK_IMPORTED_MODULE_22__modal_component_modal_component_component__["a" /* ModalComponentComponent */]],
        exports: [__WEBPACK_IMPORTED_MODULE_16__spinner_spinner_component__["a" /* SpinnerComponent */], __WEBPACK_IMPORTED_MODULE_17__core_wdfilter_pipe__["a" /* WdFilterPipe */], __WEBPACK_IMPORTED_MODULE_18__core_group_by_pipe__["a" /* GroupByPipe */], __WEBPACK_IMPORTED_MODULE_19__core_order_by_pipe__["a" /* ArraySortPipe */], __WEBPACK_IMPORTED_MODULE_22__modal_component_modal_component_component__["a" /* ModalComponentComponent */]]
    })
], WdSharedModule);

//# sourceMappingURL=wd-shared.module.js.map

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports = "<div class=\"navbar navbar-default navbar-fixed-top\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"navbar-header\">\r\n      <button type=\"button\" class=\"navbar-toggle\" (click)=\"showSidebar = !showSidebar\">\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n      </button>\r\n      <a class=\"navbar-brand\" href=\"#\">{{Title}}</a>\r\n    </div>\r\n    <div class=\"navbar-collapse collapse navbar-responsive-collapse\"> \r\n      <wd-avatar [isRoute]=\"true\" ></wd-avatar>\r\n\t</div>\r\n  </div>\r\n</div>\r\n<div class=\"side-nav-wrapper\" >\r\n  <nav class=\"side-nav\" [ngClass]=\"{'active' : showSidebar }\">\r\n    <wd-nav-menu ></wd-nav-menu>\r\n  </nav>\r\n</div>\r\n\r\n<div class=\"main-content\">\r\n  <div class=\"left-menu side-menu\">\r\n    <wd-nav-menu ></wd-nav-menu>\r\n  </div>\r\n  <div class=\"flex-1\">\r\n    <div>\r\n      <wd-message></wd-message>\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </div>\r\n  <div class=\"right-menu side-menu\">\r\n  </div>\r\n</div>\r\n\r\n<footer class=\"navbar-fixed-bottom text-center\">\r\n    <a target=\"_blank\" class=\"btn btn-info btn-raised btn-xs\" href=\"https://docs.google.com/forms/d/e/1FAIpQLSfQfhDiqvmcZTsv4ocDEM0pEHugWpRV6G2EH7RgJy1Dy1Mcjw/viewform?usp=sf_link\">Feedback? Share with us!\r\n    <span class=\"glyphicon glyphicon-comment\"></span>\r\n    </a>\r\n</footer>\r\n\r\n"

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".side-menu{width:30%;padding:10px;position:fixed;z-index:1031;top:0;margin-top:10vh}.left-menu{left:0}.right-menu{right:0}.side-nav-wrapper{width:500px;position:fixed;top:0;margin-top:50px;left:100%;max-width:200%;z-index:1}.side-nav,.side-nav-wrapper{transition:all .4s ease 0s;height:100%}.side-nav{position:absolute;width:250px;left:0;background-color:#fff;width:50%}.side-nav .navbar-nav{margin-left:0}.side-nav.active{-webkit-transform:translate(-250px);transform:translate(-250px)}.side-nav li{line-height:40px;text-indent:20px}@media (min-width:767px){.wd-content{margin-left:30%}.side-nav-wrapper{display:none}}@media (min-width:1200px){.side-menu{width:400px}.wd-content{margin-left:400px}}@media (max-width:767px){.side-menu{display:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_page_page_component__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_core_process_token_component__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_profile_component__ = __webpack_require__(274);




var appRoutes = [
    {
        path: 'process-token',
        component: __WEBPACK_IMPORTED_MODULE_2__shared_core_process_token_component__["a" /* ProcessTokenComponent */]
    },
    {
        path: 'profile',
        component: __WEBPACK_IMPORTED_MODULE_3__profile_profile_component__["a" /* ProfileComponent */]
    },
    {
        path: ':pageName',
        component: __WEBPACK_IMPORTED_MODULE_1__shared_page_page_component__["a" /* PageComponent */]
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
];
var routing = __WEBPACK_IMPORTED_MODULE_0__angular_router__["d" /* RouterModule */].forRoot(appRoutes);
//# sourceMappingURL=app.routing.js.map

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PageService = (function () {
    function PageService(http) {
        this.http = http;
    }
    PageService.prototype.getPage = function (pageName) {
        return this.http.get('pages/' + pageName + '.html?v=' + new Date().getTime(), { withCredentials: true })
            .toPromise()
            .then(function (response) { return response.text(); }).catch(this.handleError);
    };
    PageService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return PageService;
}());
PageService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object])
], PageService);

var _a;
//# sourceMappingURL=page.service.js.map

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dictaat; });
/* unused harmony export DictaatSession */
/* unused harmony export DictaatMarkingsAssignment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DictaatMarkings; });
var Dictaat = (function () {
    function Dictaat(json) {
        if (json === void 0) { json = null; }
        this.name = json.name;
        this.location = json.location;
        this.pages = json.pages;
        this.menuItems = json.menuItems;
        this.owner = json.owner;
    }
    return Dictaat;
}());

var DictaatSession = (function () {
    function DictaatSession() {
    }
    return DictaatSession;
}());

var DictaatMarkingsAssignment = (function () {
    function DictaatMarkingsAssignment(json) {
        if (json === void 0) { json = null; }
        if (json) {
            this.id = json.id;
            this.title = json.title;
            this.submissions = json.submissions;
            this.metadata = json.metadata;
        }
    }
    DictaatMarkingsAssignment.prototype.getSubmission = function (userId) {
        return this.submissions.find(function (s) { return s.userId == userId; });
    };
    return DictaatMarkingsAssignment;
}());

var DictaatMarkings = (function () {
    function DictaatMarkings(json) {
        if (json === void 0) { json = null; }
        var _this = this;
        this.participants = [];
        this.assignments = [];
        if (json) {
            this.participants = json.participants;
            json.assignments.forEach(function (a) {
                _this.assignments.push(new DictaatMarkingsAssignment(a));
            });
        }
    }
    return DictaatMarkings;
}());

//# sourceMappingURL=dictaat.js.map

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

module.exports = "<div class=\"wd-content\">\r\n    <div class=\"wd-container\">\r\n\r\n        <div class=\"panel panel-default\">\r\n          <div class=\"panel-heading\">\r\n              <h3 class=\"panel-title\">Profile information</h3>\r\n          </div>\r\n          <div class=\"panel-body\">\r\n            <div  *ngIf=\"participant\">\r\n                <div class=\"display-field\">\r\n                    <label>Username</label>\r\n                    <span>{{participant.userName}}</span>\r\n                </div>\r\n                <div class=\"display-field\">\r\n                    <label>Name</label>\r\n                    <span>{{participant.name}}</span>\r\n                </div>\r\n                <div class=\"display-field\">\r\n                    <label>Email</label>\r\n                    <span>{{participant.email}}</span>\r\n                </div>\r\n                <div class=\"display-field\">\r\n                    <label>Points</label>\r\n                    <span>{{participant.points}} avans points for this dictaat</span>\r\n                </div>\r\n            </div>\r\n            <wd-spinner  *ngIf=\"!participant\"></wd-spinner>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"panel panel-default\">\r\n          <div class=\"panel-heading\">\r\n              <h3 class=\"panel-title\">Group information</h3>\r\n          </div>\r\n          <div class=\"panel-body\">\r\n            <div *ngIf=\"participant\">\r\n\r\n                <div *ngIf=\"participant.group\">\r\n\r\n                    You are currently in group {{participant.group}}\r\n\r\n                    <div class=\"tiny-form\" >\r\n                        <label>Switch to group: </label>\r\n                        <select [(ngModel)]=\"group\" class=\"form-control wd-flex-1\">          \r\n                            <option *ngFor=\"let g of groups\" [ngValue]=\"g.groupName\">{{g.groupName}}</option>        \r\n                        </select>\r\n                        <button *ngIf=\"!isSwitching\" class=\"btn btn-md btn-raised btn-primary\" \r\n                            [disabled]=\"!group || group == participant.group\" (click)=\"switchGroup(group)\">Switch</button>\r\n                        <wd-spinner  *ngIf=\"isSwitching\"></wd-spinner>\r\n                    </div>\r\n                </div>\r\n            \r\n                <div *ngIf=\"!participant.group\">\r\n                    <p>You have not yet joined this dictaat!</p>\r\n                    \r\n                </div>\r\n\r\n\r\n            </div>  \r\n            <wd-spinner  *ngIf=\"!participant\"></wd-spinner>\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".wd-container{padding-top:20px}span{display:block}.tiny-form select{margin:0}.tiny-form{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tiny-form label{padding:3px}.display-field span{display:block;color:#000;font-size:110%}.display-field label{display:block;margin-top:10px;color:#6e6e6e;font-size:80%;margin-bottom:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createComponentFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlOutlet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__game_elements_game_elements_module__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extern_databases_datab_module__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wd_shared_module__ = __webpack_require__(44);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
//stackoverflow.com/questions/40060498/angular-2-1-0-create-child-component-on-the-fly-dynamically/40080290#40080290

//angular modules



//my modules

 //voor bart zijn datab project

function createComponentFactory(compiler, metadata) {
    var cmpClass = (function () {
        function DynamicComponent() {
        }
        return DynamicComponent;
    }());
    var decoratedCmp = Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])(metadata)(cmpClass);
    var DynamicHtmlModule = (function () {
        function DynamicHtmlModule() {
        }
        return DynamicHtmlModule;
    }());
    DynamicHtmlModule = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_3__angular_common__["b" /* CommonModule */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* RouterModule */], __WEBPACK_IMPORTED_MODULE_6__wd_shared_module__["a" /* WdSharedModule */], __WEBPACK_IMPORTED_MODULE_4__game_elements_game_elements_module__["a" /* GameElementsModule */], __WEBPACK_IMPORTED_MODULE_5__extern_databases_datab_module__["a" /* DatabModule */]
            ],
            schemas: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* CUSTOM_ELEMENTS_SCHEMA */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["L" /* NO_ERRORS_SCHEMA */]],
            declarations: [decoratedCmp]
        })
    ], DynamicHtmlModule);
    return compiler.compileModuleAndAllComponentsAsync(DynamicHtmlModule)
        .then(function (moduleWithComponentFactory) {
        return moduleWithComponentFactory.componentFactories.find(function (x) { return x.componentType === decoratedCmp; });
    });
}
var HtmlOutlet = (function () {
    function HtmlOutlet(vcRef, compiler) {
        this.vcRef = vcRef;
        this.compiler = compiler;
        this.afterCompile = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* EventEmitter */]();
    }
    HtmlOutlet.prototype.ngOnChanges = function () {
        var _this = this;
        var html = this.html;
        if (!html)
            return;
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
        var compMetadata = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */]({
            selector: 'dynamic-html',
            template: this.html,
        });
        createComponentFactory(this.compiler, compMetadata)
            .then(function (factory) {
            var injector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* ReflectiveInjector */].fromResolvedProviders([], _this.vcRef.parentInjector);
            _this.cmpRef = _this.vcRef.createComponent(factory, 0, injector, []);
            _this.afterCompile.emit();
        });
    };
    HtmlOutlet.prototype.ngOnDestroy = function () {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
    };
    return HtmlOutlet;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", String)
], HtmlOutlet.prototype, "html", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["T" /* Output */])(),
    __metadata("design:type", Object)
], HtmlOutlet.prototype, "afterCompile", void 0);
HtmlOutlet = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* Directive */])({ selector: 'html-outlet' }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["_18" /* ViewContainerRef */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["_18" /* ViewContainerRef */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* Compiler */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* Compiler */]) === "function" && _b || Object])
], HtmlOutlet);

var _a, _b;
//# sourceMappingURL=html-outlet.directive.js.map

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_rating_service__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_rating__ = __webpack_require__(452);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var RatingComponent = (function () {
    function RatingComponent(route, ratingService, accountService) {
        this.route = route;
        this.ratingService = ratingService;
        this.accountService = accountService;
        this.rate = new __WEBPACK_IMPORTED_MODULE_4__models_rating__["a" /* Rate */]();
    }
    RatingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.User.subscribe(function (user) { _this.isAuth = user != null; });
        this.route.params.forEach(function (params) {
            _this.dictaatName = params['dictaatName'];
            _this.ratingService.getRating(_this.dictaatName, _this.rid)
                .then(function (rating) {
                _this.rating = rating;
            })
                .catch(function (reason) { return _this.error = reason; });
        });
    };
    RatingComponent.prototype.login = function () {
        this.accountService.Login();
    };
    RatingComponent.prototype.sendRate = function () {
        var _this = this;
        this.ratingService.SendRate(this.dictaatName, this.rating.id, this.rate)
            .then(function (rating) {
            _this.rating = rating;
            _this.rate = null;
        });
    };
    RatingComponent.prototype.setEmotion = function (emotion) {
        if (this.rate.emotion == emotion) {
            this.rate.emotion = null;
        }
        else {
            this.rate.emotion = emotion;
        }
    };
    return RatingComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], RatingComponent.prototype, "rid", void 0);
RatingComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-rating",
        styles: [__webpack_require__(453)],
        template: __webpack_require__(454)
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_rating_service__["a" /* RatingService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_rating_service__["a" /* RatingService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_account_service__["a" /* AccountService */]) === "function" && _c || Object])
], RatingComponent);

var _a, _b, _c;
//# sourceMappingURL=rating.component.js.map

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rating */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rate; });
var Rating = (function () {
    function Rating() {
        this.description = false;
    }
    return Rating;
}());

var Rate = (function () {
    function Rate() {
    }
    return Rate;
}());

//# sourceMappingURL=rating.js.map

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".emotion img{width:35px;cursor:pointer;transition:all .4s;margin:4px}.emotion{position:relative}.emotion.active img{-webkit-transform:scale(1.1);transform:scale(1.1)}.rate{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.text-baloon{position:absolute;top:-61px;left:0}.text-baloon .content{display:-webkit-box;display:-ms-flexbox;display:flex;padding:3px}.text-baloon .content button{margin:0}.text-baloon .content input{height:100%;padding:12px;margin:2px;width:300px;max-width:100%;border:0}.text-baloon{text-align:center;padding:0;background:#fff;border-radius:2px;box-shadow:0 1px 6px 0 rgba(0,0,0,.12),0 1px 6px 0 rgba(0,0,0,.12)}.text-baloon:after{content:\"\";position:absolute;border-style:solid;border-width:15px 15px 0;border-color:#fff transparent;display:block;width:0;z-index:1;bottom:-10px;left:7px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

module.exports = " <div>\r\n        <div *ngIf=\"error\" class=\"alert alert-danger\">\r\n            <p>{{error}}</p>\r\n        </div>\r\n\r\n        <div class=\"bs-callout bs-callout-info\" *ngIf=\"rating\" >\r\n               \r\n            <h4>{{rating.title}}</h4>\r\n\r\n            <div *ngIf=\"!isAuth\">\r\n                 <button class='btn btn-info btn-raised' (click)=\"login()\">Login to give feedback</button>\r\n            </div>\r\n\r\n            <div *ngIf=\"isAuth\">\r\n\r\n                <div *ngIf=\"!rating.myRate\" class=\"rate\">\r\n                    <span class=\"count\">{{rating.sadCounter}}</span>\r\n                    <div class='emotion' [ngClass]=\"{ 'active' : rate.emotion == 'sad' }\">       \r\n                        <img (click)=\"setEmotion('sad')\"   src=\"https://webdictaat.azurewebsites.net/images/shared/sad.png\">\r\n                       \r\n                        <div  *ngIf=\"rate.emotion == 'sad'\" class=\"text-baloon\">\r\n                             <div class=\"content\">\r\n                                <input [(ngModel)]='rate.feedback' id=\"textArea\" placeholder=\"I feel sad because...\" />\r\n                                <button class='btn btn-info btn-raised' (click)=\"sendRate()\" >Send rating</button>\r\n                             </div>\r\n                        </div>\r\n                    </div>\r\n                    <span class=\"count\">{{rating.happyCounter}}</span>\r\n                    <div  class='emotion' [ngClass]=\"{ 'active' : rate.emotion == 'happy' }\">\r\n                        <img (click)=\"setEmotion('happy')\"  src=\"https://webdictaat.azurewebsites.net/images/shared/happy.png\">\r\n                        \r\n                        <div  *ngIf=\"rate.emotion == 'happy'\" class=\"text-baloon\">\r\n                            <div class=\"content\">\r\n                                <input [(ngModel)]='rate.feedback' id=\"textArea\" placeholder=\"I feel happy because...\" />\r\n                                <button class='btn btn-info btn-raised' (click)=\"sendRate()\" >Send rating</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                 \r\n                </div>\r\n\r\n                <div *ngIf=\"rating.myRate\">\r\n                    \r\n                    <p *ngIf=\"rating.myRate.feedback\"> \r\n                        <span class=\"count\">{{rating.sadCounter}}</span>\r\n                        <img width=\"30px\" src=\"https://webdictaat.azurewebsites.net/images/shared/sad.png\">\r\n                        <span class=\"count\">{{rating.happyCounter}}</span>\r\n                        <img width=\"30px\" src=\"https://webdictaat.azurewebsites.net/images/shared/happy.png\">\r\n                        - \"{{rating.myRate.feedback}}\"\r\n                    </p>\r\n                </div>\r\n\r\n\r\n            </div>\r\n        </div>\r\n    </div>"

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AchievementsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_achievement_service__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_config_service__ = __webpack_require__(18);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AchievementsComponent = (function () {
    function AchievementsComponent(achievementService, configService) {
        this.achievementService = achievementService;
        this.configService = configService;
        this.grid = true;
    }
    AchievementsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configService.Config.subscribe(function (config) {
            if (config) {
                _this.achievementService.getDictaatAchievements(config.name).then(function (achievements) {
                    _this.achievementgroups = achievements ? achievements : [];
                    _this.getAllAchievements();
                });
            }
        });
    };
    AchievementsComponent.prototype.getAllAchievements = function () {
        for (var _i = 0, _a = this.achievementgroups; _i < _a.length; _i++) {
            var group = _a[_i];
            for (var _b = 0, _c = group.achievements; _b < _c.length; _b++) {
                var achiev = _c[_b];
                this.achievements.push(achiev);
            }
        }
    };
    return AchievementsComponent;
}());
AchievementsComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-achievements",
        template: __webpack_require__(456),
        styles: [__webpack_require__(457)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__services_achievement_service__["a" /* AchievementService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_achievement_service__["a" /* AchievementService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */]) === "function" && _b || Object])
], AchievementsComponent);

var _a, _b;
//# sourceMappingURL=achievements.component.js.map

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports = "<div class=\"wd-component\" *ngIf=\"achievementgroups\">\r\n    <div *ngIf=\"achievementgroups.length > 0\">\r\n        <div class=\"container\">\r\n            <div class=\"buttoncontainer\">\r\n                <button class=\"listbutton\" *ngIf=\"grid\" (click)=\"grid = false\">list</button>\r\n                <button class=\"listbutton\" *ngIf=\"!grid\" (click)=\"grid = true\">grid</button>\r\n            </div>\r\n            <div class=\"achievementscontainer\">\r\n                <div *ngIf=\"grid\" class=\"flex1\">\r\n                    <div *ngFor=\"let achievement of achievements\">\r\n                        <div *ngIf=\"achievement.hidden && achievement.completed || !achievement.hidden\">\r\n                            <div class=\"achievement\" [ngClass]=\"{'completed':  achievement.completed}\">\r\n                                <img class=\"achievementimage\" [src]=\"'/images/achievements/' + achievement.image + '.jpg'\" />\r\n                                <p><b>{{achievement.name}}</b></p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"!grid\">\r\n                    <div *ngFor=\"let group of achievementgroups\">\r\n                        <div class=\"listgroup\">\r\n                            <h2>{{group.groupName}}</h2>\r\n                            <div *ngFor=\"let achievement of group.achievements\">\r\n                                <div *ngIf=\"achievement.hidden && achievement.completed || !achievement.hidden\">\r\n\r\n                                    <div class=\"achievement\" [ngClass]=\"{'completed':  achievement.completed}\">\r\n\r\n                                        <img class=\"achievementimage\" [src]=\"'/images/achievements/' + achievement.image + '.jpg'\" />\r\n                                        <p><b>{{achievement.name}}</b></p>\r\n                                    </div>\r\n\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"achievementgroups.length == 0\">\r\n        <div class=\"alert alert-dismissible alert-info\" *ngIf=\"!hide\" >\r\n                <button type=\"button\" class=\"close\" (click)=\"hide = true\">×</button>\r\n                <strong>Ow noes!</strong>\r\n                <p>The achievements are still at the achievements factory! Contact you're teacher for more information. </p>\r\n                \r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".container{background-color:#fdfffd;box-shadow:5px 5px 5px #888;height:300px;min-width:150px;width:100%;overflow:hidden;border:1px solid}.achievementscontainer{height:300px;width:100%;overflow:auto}.flex1{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-line-pack:start;align-content:flex-start}.achievement{height:200px;width:150px;margin:5px;border-radius:5px;overflow:hidden;float:left;text-align:center;box-shadow:5px 5px 5px #888;background-color:#dedece;opacity:.5}.achievementimage{height:150px;width:150px}.completed{opacity:1}.achievementinfo{background-color:#a9a9a9;width:75px;height:40px;position:absolute;text-align:center;display:none}.achivementinfo p{line-height:0}.buttoncontainer{padding-right:10px;width:100%;height:40px;float:left}.listgroup{float:left;width:100%;margin-bottom:50px}.listbutton{margin-right:10px;margin-top:5px;float:right}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuizModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quiz_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__question_quiz_question_component__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__question_mc_question_mc_component__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__question_blanks_question_blanks_component__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__question_question_group_question_group_component__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__question_question_sentence_question_sentence_component__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wd_shared_module__ = __webpack_require__(44);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var QuizModule = (function () {
    function QuizModule() {
    }
    return QuizModule;
}());
QuizModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        providers: [],
        imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_11__wd_shared_module__["a" /* WdSharedModule */], __WEBPACK_IMPORTED_MODULE_3__angular_forms__["a" /* FormsModule */], __WEBPACK_IMPORTED_MODULE_8__angular_common__["b" /* CommonModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_4__quiz_component__["a" /* QuizComponent */], __WEBPACK_IMPORTED_MODULE_5__question_quiz_question_component__["a" /* QuestionComponent */], __WEBPACK_IMPORTED_MODULE_6__question_mc_question_mc_component__["a" /* QuestionMcComponent */], __WEBPACK_IMPORTED_MODULE_7__question_blanks_question_blanks_component__["a" /* QuestionBlanksComponent */], __WEBPACK_IMPORTED_MODULE_9__question_question_group_question_group_component__["a" /* QuestionGroupComponent */], __WEBPACK_IMPORTED_MODULE_10__question_question_sentence_question_sentence_component__["a" /* QuestionSentenceComponent */]],
        exports: [__WEBPACK_IMPORTED_MODULE_4__quiz_component__["a" /* QuizComponent */], __WEBPACK_IMPORTED_MODULE_5__question_quiz_question_component__["a" /* QuestionComponent */], __WEBPACK_IMPORTED_MODULE_6__question_mc_question_mc_component__["a" /* QuestionMcComponent */], __WEBPACK_IMPORTED_MODULE_7__question_blanks_question_blanks_component__["a" /* QuestionBlanksComponent */]]
    })
], QuizModule);

//# sourceMappingURL=quiz.module.js.map

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

module.exports = "<div class=\"bs-callout bs-callout-default quiz\" [ngClass]=\"{'complete': quiz ? quiz.isComplete : false}\">\r\n\r\n  <wd-spinner [subtitle]=\"'Loading quiz'\" *ngIf=\"isLoading\"></wd-spinner>\r\n\r\n  <div *ngIf=\"quiz\">\r\n\r\n    <header>\r\n      <h2>Quiz - {{quiz.assignment.title}}\r\n        <span>({{quiz.questions.length}} questions)</span>\r\n      </h2>\r\n      <div class=\"tooltip-container\">\r\n\r\n        <!-- Edit only visible in CMS -->\r\n        <span class=\"tooltip-item edit\" (click)=\"edit()\">\r\n          <span class=\"glyphicon glyphicon-pencil\"  aria-hidden=\"true\"></span>\r\n        </span>\r\n\r\n\r\n        <span class=\"tooltip-item success\" *ngIf=\"quiz.isComplete\">\r\n              <span class=\"glyphicon glyphicon-ok\"  aria-hidden=\"true\"></span>\r\n        <span class=\"tooltip\">yay! This quiz was completed on {{quiz.lastAttempt.timestamp | date}}</span>\r\n        </span>\r\n        <span class=\"tooltip-item points\">\r\n              <span>{{quiz.assignment.points}}</span>\r\n        </span>\r\n      </div>\r\n    </header>\r\n\r\n    <div class=\"body\">\r\n\r\n      <!-- IDLE -->\r\n      <div *ngIf=\"quiz.status == 'idle'\" class='idle'>\r\n        <p>{{quiz.assignment.description}}</p>\r\n\r\n        <button *ngIf=\"isAuth\" (click)=\"start()\" class='btn btn-info btn-raised'>Start</button>\r\n        <button *ngIf=\"!isAuth\" (click)=\"login()\" class='btn btn-info btn-raised'>Login to start Quiz</button>\r\n      </div>\r\n\r\n      <!-- STARTED -->\r\n      <div *ngIf=\"quiz.status == 'started'\" class='started'>\r\n        <wd-quiz-question [question]=\"quiz.current\" (onAnswer)=\"continue()\">\r\n        </wd-quiz-question>\r\n      </div>\r\n\r\n      \r\n      <!-- TEMPORARY -->\r\n      <div *ngIf=\"quiz.status == 'temporary'\" class='temporary text-center'>\r\n          <button *ngIf=\"isAuth\" (click)=\"quiz.status = 'started'\" class='btn btn-info btn-raised'>Continue where i left off</button>\r\n          <div *ngIf=\"!limit\">\r\n            <fieldset class=\"breakline\">\r\n              <legend>Or</legend>\r\n            </fieldset>\r\n            <button *ngIf=\"isAuth\" (click)=\"start()\" class='btn btn-info'>Restart quiz</button>\r\n          </div>\r\n      </div>  \r\n\r\n      <!-- FINISHED -->\r\n      <div *ngIf=\"quiz.status == 'finished' && !isSubmitting\" class='finished'>\r\n        <p>You got {{quiz.lastAttempt.correctAnswers}} out of {{quiz.questions.length}}!</p>\r\n        <div class=\"progress line\" [ngStyle]=\"{'width': quiz.lastAttempt.questionsAnswered.length * 50 + 'px'}\">\r\n          <div class=\"point\" *ngFor=\"let q of quiz.lastAttempt.questionsAnswered\" [ngClass]=\"q.isCorrect ? 'correct' : 'wrong'\">\r\n            {{isCorrect}}\r\n          </div>\r\n        </div>\r\n        <button *ngIf=\"!limit\" (click)=\"retakeQuiz()\" class=\"btn btn-info btn-sm btn-raised\">Retake quiz</button>\r\n      </div>\r\n      <!-- Show loader -->\r\n      <div *ngIf=\"isSubmitting\"  class='finished'>\r\n          <wd-spinner [subtitle]=\"'Checking answers'\" ></wd-spinner>\r\n      </div>\r\n\r\n    </div>\r\n  </div>"

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".question-progress{list-style-type:none;padding:0}.question-progress li{display:inline-block}h2{font-size:150%;margin:0}h1 span{font-size:16px}.quiz{background-color:#fff;min-height:100px}.quiz .finished,.quiz .idle,.quiz .temporary,header{padding:20px}header{margin:10px 0;border-bottom:1px solid #ddd;position:relative}.quiz.complete .points{color:#fff;background-color:#66bb6a}.score{margin:5px}.bs-callout{padding:0}.bs-callout.complete{border-left-color:#66bb6a}fieldset.breakline{margin-bottom:0}.started .footer{height:100px;width:100%;background-color:#eee}.progress{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:20px;overflow:visible}.progress .point{width:20px;height:20px;border-radius:50%;border:2px solid #c8c8c8;background-color:#fff}.progress .point.correct{background-color:#66bb6a}.progress .point.wrong{background-color:#f44336}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_quiz_question__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__question_base__ = __webpack_require__(56);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var QuestionComponent = (function () {
    function QuestionComponent() {
        this.onAnswer = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* EventEmitter */]();
        this.state = 'idle';
    }
    QuestionComponent.prototype.ngOnInit = function () {
        this.checker = new __WEBPACK_IMPORTED_MODULE_2__question_base__["a" /* Checker */]();
    };
    QuestionComponent.prototype.check = function () {
        this.checker.isChecking = true;
        this.state = this.question.isCorrect ? 'correct' : 'wrong';
    };
    QuestionComponent.prototype.continue = function () {
        this.checker.reset();
        this.state = 'idle';
        this.onAnswer.emit();
    };
    return QuestionComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__models_quiz_question__["a" /* Question */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_quiz_question__["a" /* Question */]) === "function" && _a || Object)
], QuestionComponent.prototype, "question", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["T" /* Output */])(),
    __metadata("design:type", Object)
], QuestionComponent.prototype, "onAnswer", void 0);
QuestionComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-quiz-question',
        template: __webpack_require__(462),
        styles: [__webpack_require__(463)]
    }),
    __metadata("design:paramtypes", [])
], QuestionComponent);

var _a;
//# sourceMappingURL=quiz-question.component.js.map

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"question\" >\r\n\r\n    <div class=\"body\">\r\n        <h4><b>{{question.text}}</b></h4>\r\n\r\n        <!-- content -->\r\n        <div [ngSwitch]=\"question.type\">\r\n            <wd-question-mc *ngSwitchCase=\"'mc'\" [question]=\"question\" [checker]=\"checker\"></wd-question-mc>\r\n            <wd-question-blanks *ngSwitchCase=\"'blanks'\" [question]=\"question\" [checker]=\"checker\"></wd-question-blanks>\r\n            <wd-question-group *ngSwitchCase=\"'group'\" [question]=\"question\" [checker]=\"checker\"></wd-question-group>\r\n            <wd-question-sentence *ngSwitchCase=\"'sentence'\" [question]=\"question\" [checker]=\"checker\"></wd-question-sentence>\r\n            \r\n        </div>\r\n    </div>\r\n\r\n    <!-- Controls -->\r\n    <div class=\"footer\"  >\r\n\r\n        <div class='state-icon' >\r\n            <div class=\"state-icon-slider\" [ngClass]=\"state\">\r\n                <span class=\"glyphicon correct glyphicon-ok\" aria-hidden=\"true\"></span> \r\n                <span class=\"icon\">?</span>\r\n                <span class=\"glyphicon wrong glyphicon-remove\" aria-hidden=\"true\"></span> \r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"explanation\" [hidden]=\"!checker.isChecking\">\r\n            <h2 [ngClass]=\"state\">{{state}}.</h2>\r\n            <p *ngIf=\"question.explanation\" class=\"wrapword\"><b>explanation:</b> {{question.explanation}}</p>\r\n        </div>\r\n\r\n        <div class=\"actions\">\r\n\r\n            <button \r\n                class=\"btn btn-raised btn-default next\" \r\n                *ngIf=\"!checker.isChecking\" \r\n                [disabled]=\"checker.canCheck\" \r\n                (click)=\"check()\" >\r\n                Check\r\n            </button>\r\n            \r\n            <button \r\n                class=\"btn btn-raised btn-default next\" \r\n                *ngIf=\"checker.isChecking\"\r\n                (click)=\"continue()\" >\r\n                Continue\r\n            </button>\r\n        </div>\r\n       \r\n        \r\n    </div>\r\n\r\n</div>\r\n"

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".footer{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#ddd;width:100%;transition:all .5s}.body,.footer{padding:20px}.state-icon{border-radius:50%;font-size:120%;height:100%;width:50px;background-color:#eee;color:#999;position:relative;overflow:hidden}.state-icon-slider{box-sizing:border-box;width:300%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-transform:translateX(-50px);transform:translateX(-50px);transition:-webkit-transform .5s ease-in;transition:transform .5s ease-in;transition:transform .5s ease-in,-webkit-transform .5s ease-in}.state-icon-slider.wrong{-webkit-transform:translateX(-100px);transform:translateX(-100px)}.state-icon-slider.correct{-webkit-transform:translateX(0);transform:translateX(0)}.state-icon-slider span{line-height:50px;width:50px;display:inline-block;text-align:center;border-radius:50%}.state-icon-slider span.wrong{background-color:#f44336;color:#fff}.state-icon-slider span.correct{background-color:#66bb6a;color:#fff}.explanation{text-align:center;-webkit-box-flex:1;-ms-flex:1;flex:1;margin:0 15px}.explanation h2{margin:0}.explanation h2.wrong{color:#b71c1c}.explanation h2.correct{color:#1b5e20}@media (max-width:767px){.footer .explanation{-webkit-box-flex:1;-ms-flex:1 0 100%;flex:1 0 100%;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;min-height:50px;margin-bottom:5px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionMcComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__question_base__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var QuestionMcComponent = (function (_super) {
    __extends(QuestionMcComponent, _super);
    function QuestionMcComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionMcComponent.prototype.ngOnInit = function () {
    };
    QuestionMcComponent.prototype.isSelected = function (answer) {
        return answer == this.answer;
    };
    QuestionMcComponent.prototype.selectAnswer = function (answer) {
        if (!this.checker.isChecking) {
            this.answer = answer;
            this.checkIfCorrect();
        }
    };
    QuestionMcComponent.prototype.checkIfCorrect = function () {
        //only need to check first question.
        this.question.isCorrect = this.answer.isCorrect;
    };
    return QuestionMcComponent;
}(__WEBPACK_IMPORTED_MODULE_1__question_base__["b" /* QuestionBase */]));
QuestionMcComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-question-mc',
        template: __webpack_require__(465),
        styles: [__webpack_require__(466)]
    })
], QuestionMcComponent);

//# sourceMappingURL=question-mc.component.js.map

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

module.exports = "<div *ngFor='let answer of question.body.answers'>\r\n    <button class=\"btn btn-raised btn-default answer\" \r\n            [disabled]=\"\"\r\n            (click)=\"selectAnswer(answer)\"  \r\n            [ngClass]=\"{'btn-info' : isSelected(answer), 'checking': checker.isChecking}\">\r\n            {{answer.text}}\r\n    </button>\r\n    <label *ngIf=\"checker.isChecking\">\r\n        <span *ngIf=\"answer.isCorrect\" class=\"badge success\">Correct</span>\r\n        <span *ngIf=\"!answer.isCorrect\" class=\"badge danger\">Incorrect</span>\r\n    </label>\r\n</div>"

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".badge{border-radius:3px;margin-left:3px}.badge.danger{background-color:#f44336}.badge.success{background-color:#66bb6a}button.checking{cursor:not-allowed;opacity:.5}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionBlanksComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__question_base__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var QuestionBlanksComponent = (function (_super) {
    __extends(QuestionBlanksComponent, _super);
    function QuestionBlanksComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textParts = [];
        _this.options = [];
        return _this;
    }
    QuestionBlanksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.textParts = this.getParts(this.question.body.sentence);
        this.textParts.forEach(function (tp) {
            if (tp.type === 'blank') {
                _this.options.push(tp);
            }
        });
        if (this.question.body.answers) {
            this.question.body.answers.forEach(function (a) {
                _this.options.push(new __WEBPACK_IMPORTED_MODULE_1__question_base__["c" /* TextPart */](a.text));
            });
        }
        this.shuffle(this.options);
    };
    QuestionBlanksComponent.prototype.remove = function (part) {
        if (!this.checker.isChecking) {
            var answer = part.value;
            this.options.push(answer);
            part.value = null;
        }
    };
    QuestionBlanksComponent.prototype.select = function (selectedPart) {
        var _this = this;
        //place on next possible 
        this.textParts.some(function (part, i) {
            if (part.type == 'blank' && !part.value) {
                part.value = selectedPart;
                _this.options.splice(_this.options.indexOf(selectedPart), 1);
                _this.checkIfCorrect();
                return true;
            }
        });
    };
    QuestionBlanksComponent.prototype.checkIfCorrect = function () {
        var isCorrect = true;
        this.textParts.forEach(function (part) {
            if (part.type == 'blank' && (!part.value || (part.value.text != part.text))) {
                isCorrect = false;
            }
        });
        this.question.isCorrect = isCorrect;
    };
    QuestionBlanksComponent.prototype.canSelect = function () {
    };
    return QuestionBlanksComponent;
}(__WEBPACK_IMPORTED_MODULE_1__question_base__["b" /* QuestionBase */]));
QuestionBlanksComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-question-blanks',
        template: __webpack_require__(468),
        styles: [__webpack_require__(469)]
    })
], QuestionBlanksComponent);

//# sourceMappingURL=question-blanks.component.js.map

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

module.exports = "<h4 class=\"word-container\" *ngIf=\"textParts\">\r\n  <span *ngFor=\"let part of textParts\">\r\n    <span *ngIf=\"part.type == 'text'\">\r\n      {{part.text}}\r\n    </span>\r\n    <span *ngIf=\"part.type == 'blank'\">\r\n      <span *ngIf=\"part.value\">\r\n          <button class=\"btn btn-raised btn-sm btn-default answer\" (click)=\"remove(part)\">\r\n              {{part.value.text}}\r\n          </button>\r\n      </span>\r\n      <span *ngIf=\"!part.value\">...</span>\r\n    </span>\r\n  </span>\r\n\r\n</h4>\r\n\r\n<h3>Options</h3>\r\n<button class=\"btn btn-raised btn-default answer\"  *ngFor='let part of options'\r\n        (click)=\"select(part)\">\r\n    {{part.text}}\r\n</button>\r\n"

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".btn-sm{margin-left:3px;margin-right:3px}.word-container{min-height:60px;line-height:45px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionGroupComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__question_base__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var QuestionGroupComponent = (function (_super) {
    __extends(QuestionGroupComponent, _super);
    function QuestionGroupComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionGroupComponent.prototype.ngOnInit = function () {
        this.selectedAnswers = [];
    };
    QuestionGroupComponent.prototype.toggleAnswer = function (answer) {
        if (!this.checker.isChecking) {
            if (this.isSelected(answer)) {
                //remove answer
                this.selectedAnswers.splice(this.selectedAnswers.indexOf(answer), 1);
            }
            else {
                //add answer
                this.selectedAnswers.push(answer);
            }
            this.checkIfCorrect();
        }
    };
    QuestionGroupComponent.prototype.isSelected = function (answer) {
        return this.selectedAnswers.indexOf(answer) != -1;
    };
    QuestionGroupComponent.prototype.checkIfCorrect = function () {
        var _this = this;
        var isCorrect = true;
        //check if all correct answers are selected
        this.question.body.answers.forEach(function (answer) {
            if (answer.isCorrect && !_this.isSelected(answer)) {
                isCorrect = false;
            }
        });
        //check if all selected answers are correct
        this.selectedAnswers.forEach(function (answer) {
            if (!answer.isCorrect) {
                isCorrect = false;
            }
        });
        this.question.isCorrect = isCorrect;
    };
    return QuestionGroupComponent;
}(__WEBPACK_IMPORTED_MODULE_1__question_base__["b" /* QuestionBase */]));
QuestionGroupComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-question-group',
        template: __webpack_require__(471),
        styles: [__webpack_require__(472)]
    })
], QuestionGroupComponent);

//# sourceMappingURL=question-group.component.js.map

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-raised btn-default answer\" *ngFor='let answer of question.body.answers'\r\n        [disabled]=\"\"\r\n        (click)=\"toggleAnswer(answer)\"  \r\n        [ngClass]=\"{'btn-info' : isSelected(answer), 'checking': checker.isChecking}\">\r\n        {{answer.text}}\r\n</button>\r\n"

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".badge{border-radius:3px;margin-left:3px}.badge.danger{background-color:#f44336}.badge.success{background-color:#66bb6a}button.checking{cursor:not-allowed;opacity:.5}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionSentenceComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__question_base__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var QuestionSentenceComponent = (function (_super) {
    __extends(QuestionSentenceComponent, _super);
    function QuestionSentenceComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionSentenceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._original = this.getParts(this.question.body.sentence);
        this.Options = this.shuffle(this.getParts(this.question.body.sentence));
        this.question.body.answers.forEach(function (a) { return _this.Options.push(new __WEBPACK_IMPORTED_MODULE_1__question_base__["c" /* TextPart */](a.text)); });
        this.shuffle(this.Options);
        this.Sentence = [];
    };
    QuestionSentenceComponent.prototype.select = function (textPart) {
        this.Sentence.push(textPart);
        this.Options.splice(this.Options.indexOf(textPart), 1);
        this.checkIfCorrect();
    };
    QuestionSentenceComponent.prototype.deselect = function (textPart) {
        this.Options.push(textPart);
        this.Sentence.splice(this.Sentence.indexOf(textPart), 1);
        this.checkIfCorrect();
    };
    QuestionSentenceComponent.prototype.checkIfCorrect = function () {
        var originalSentence = "";
        this._original.forEach(function (part) { return originalSentence += part.text; });
        var currentSentence = "";
        this.Sentence.forEach(function (part) { return currentSentence += part.text; });
        this.question.isCorrect = originalSentence == currentSentence;
    };
    return QuestionSentenceComponent;
}(__WEBPACK_IMPORTED_MODULE_1__question_base__["b" /* QuestionBase */]));
QuestionSentenceComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-question-sentence',
        template: __webpack_require__(474),
        styles: [__webpack_require__(475)]
    })
], QuestionSentenceComponent);

//# sourceMappingURL=question-sentence.component.js.map

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

module.exports = "<div class=\"word-container\">\r\n    <button class=\"btn btn-raised btn-default answer\"  *ngFor='let part of Sentence'\r\n    (click)=\"deselect(part)\">\r\n    {{part.text}}\r\n    </button>    \r\n</div>\r\n\r\n<h3>Choose from the following words</h3>\r\n<div class=\"word-container\">\r\n    <button class=\"btn btn-raised btn-default answer\"  *ngFor='let part of Options'\r\n        (click)=\"select(part)\">\r\n    {{part.text}}\r\n    </button>\r\n</div>\r\n"

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".word-container{min-height:60px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DialogData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


//Nodig om een object om te toveren in een promise.



var DialogData = (function () {
    function DialogData() {
    }
    return DialogData;
}());

var DialogService = (function () {
    function DialogService(http) {
        this.http = http;
        this.subject = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    DialogService.prototype.showDialog = function (title, content) {
        this.dialogData = { Title: title, Content: content };
        this.subject.next(this.dialogData);
    };
    DialogService.prototype.getDialogData = function () {
        return this.subject.asObservable();
    };
    DialogService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return DialogService;
}());
DialogService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]) === "function" && _a || Object])
], DialogService);

var _a;
//# sourceMappingURL=dialog.service.js.map

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var ImageService = (function (_super) {
    __extends(ImageService, _super);
    function ImageService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    ImageService.prototype.addImages = function (dictaatName, image) {
        var url = "/dictaten/" + dictaatName + '/upload';
        return this.wdapi.postFile(url, image);
    };
    ImageService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return ImageService;
}(__WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__["a" /* BaseModalService */]));
ImageService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], ImageService);

var _a;
//# sourceMappingURL=images.service.js.map

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirtyGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DirtyGuard = (function () {
    function DirtyGuard() {
    }
    DirtyGuard.prototype.canDeactivate = function (component) {
        if (component.isDirty()) {
            return confirm("You have unsaved changes. Would you like to discard these changes?");
        }
        return true;
    };
    return DirtyGuard;
}());
DirtyGuard = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])()
], DirtyGuard);

//# sourceMappingURL=dirty.guard.js.map

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var VideoService = (function (_super) {
    __extends(VideoService, _super);
    function VideoService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    VideoService.prototype.handleError = function (error) {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    };
    return VideoService;
}(__WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__["a" /* BaseModalService */]));
VideoService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], VideoService);

var _a;
//# sourceMappingURL=video.service.js.map

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var SpinnerComponent = (function () {
    function SpinnerComponent() {
    }
    SpinnerComponent.prototype.ngOnInit = function () { };
    return SpinnerComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", String)
], SpinnerComponent.prototype, "subtitle", void 0);
SpinnerComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-spinner",
        styles: [__webpack_require__(481)],
        template: "\n        <div class=\"spinner\">\n            <div class=\"rect1\"></div>\n            <div class=\"rect2\"></div>\n            <div class=\"rect3\"></div>\n            <div class=\"rect4\"></div>\n            <div class=\"rect5\"></div>\n        </div>\n        <div class=\"subtitle\">{{subtitle ? subtitle : 'loading content'}}</div>\n    \n    "
    }),
    __metadata("design:paramtypes", [])
], SpinnerComponent);

//# sourceMappingURL=spinner.component.js.map

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".subtitle{color:#bebebe;text-align:center;font-style:Italic}.spinner{margin:10px auto;width:50px;height:40px;text-align:center;font-size:10px}.spinner>div{background-color:#333;height:100%;width:6px;display:inline-block;-webkit-animation:sk-stretchdelay 1.2s infinite ease-in-out;animation:sk-stretchdelay 1.2s infinite ease-in-out}.spinner .rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.spinner .rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.spinner .rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.spinner .rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes sk-stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WdFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var WdFilterPipe = (function () {
    function WdFilterPipe() {
    }
    WdFilterPipe.prototype.transform = function (items, filter) {
        if (!items || !filter || !filter.value || !filter.property) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        items = items.filter(function (item) {
            if (item[filter.property]) {
                return item[filter.property].toUpperCase().indexOf(filter.value.toUpperCase()) !== -1;
            }
        });
        return items;
    };
    return WdFilterPipe;
}());
WdFilterPipe = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Pipe */])({
        name: 'wdfilter',
        pure: false
    })
], WdFilterPipe);

//# sourceMappingURL=wdfilter.pipe.js.map

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupByPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var GroupByPipe = (function () {
    function GroupByPipe() {
    }
    GroupByPipe.prototype.transform = function (value, field) {
        var groupedObj = value.reduce(function (prev, cur) {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            }
            else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        return Object.keys(groupedObj).map(function (key) { return ({ key: key, value: groupedObj[key] }); });
    };
    return GroupByPipe;
}());
GroupByPipe = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Pipe */])({ name: 'wdGroupBy' })
], GroupByPipe);

//# sourceMappingURL=group-by.pipe.js.map

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArraySortPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ArraySortPipe = (function () {
    function ArraySortPipe() {
    }
    ArraySortPipe.prototype.transform = function (array, args) {
        array.sort(function (a, b) {
            if (a < b) {
                return -1;
            }
            else if (a > b) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return array;
    };
    return ArraySortPipe;
}());
ArraySortPipe = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Pipe */])({
        name: "wdsort"
    })
], ArraySortPipe);

//# sourceMappingURL=order-by.pipe.js.map

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var StylingService = (function (_super) {
    __extends(StylingService, _super);
    function StylingService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    StylingService.prototype.getStyle = function (dictaatName, styleName) {
        var url = "/dictaten/" + dictaatName + '/styling/' + styleName;
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) { return response.text(); });
    };
    StylingService.prototype.updateStyle = function (dictaatName, styleName, content) {
        var url = "/dictaten/" + dictaatName + '/styling/' + styleName;
        return this.wdapi.put(url, { content: content })
            .toPromise()
            .then(function (response) { return response._body; });
    };
    return StylingService;
}(__WEBPACK_IMPORTED_MODULE_3__shared_core_basemodal_service__["a" /* BaseModalService */]));
StylingService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__shared_core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], StylingService);

var _a;
//# sourceMappingURL=styling.service.js.map

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalComponentComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ModalComponentComponent = (function () {
    function ModalComponentComponent() {
        this.isValid = true;
        this.onComplete = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* EventEmitter */]();
        this.onCancel = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* EventEmitter */]();
    }
    ModalComponentComponent.prototype.ngOnInit = function () {
        if (!this.config)
            this.config = {};
    };
    ModalComponentComponent.prototype.cancel = function () {
        this.isVisible = false;
        this.onCancel.emit(null);
    };
    ModalComponentComponent.prototype.complete = function () {
        this.onComplete.emit(null);
    };
    return ModalComponentComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Boolean)
], ModalComponentComponent.prototype, "isVisible", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Object)
], ModalComponentComponent.prototype, "config", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Boolean)
], ModalComponentComponent.prototype, "isValid", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["T" /* Output */])(),
    __metadata("design:type", Object)
], ModalComponentComponent.prototype, "onComplete", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["T" /* Output */])(),
    __metadata("design:type", Object)
], ModalComponentComponent.prototype, "onCancel", void 0);
ModalComponentComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-modal',
        template: __webpack_require__(487),
        styles: [__webpack_require__(488)]
    }),
    __metadata("design:paramtypes", [])
], ModalComponentComponent);

//# sourceMappingURL=modal-component.component.js.map

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports = "<div id=\"myModal\" class=\"modal animated fadeIn\" role=\"dialog\" *ngIf=\"isVisible\">\r\n    <div class=\"modal-dialog animated fadeInDown\">\r\n      <!-- Modal content-->\r\n      <div class=\"modal-content\">\r\n  \r\n        <div class=\"modal-header\">\r\n          <h4 class=\"modal-title\">\r\n              {{config.title ? config.title : 'New modal' }}\r\n          </h4>\r\n          <div class=\"close-modal-button\" (click)=\"cancel()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n          </div>\r\n        </div>\r\n  \r\n        <div class=\"modal-body\">\r\n            <ng-content></ng-content>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-default\" (click)=\"cancel()\">Cancel</button>\r\n            <div class=\"seperator\"></div>\r\n            <button class=\"btn btn-success\" (click)=\"complete()\" [disabled]=\"!isValid\">\r\n              {{config.savetext ? config.savetext : 'Save'}}\r\n            </button>\r\n        </div>\r\n        \r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n"

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LeaderboardModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__leaderboard_component__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__totalpoints_pipe__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wd_shared_module__ = __webpack_require__(44);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var LeaderboardModule = (function () {
    function LeaderboardModule() {
    }
    return LeaderboardModule;
}());
LeaderboardModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        providers: [],
        imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_6__wd_shared_module__["a" /* WdSharedModule */], __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* HttpModule */], __WEBPACK_IMPORTED_MODULE_3__angular_forms__["a" /* FormsModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_4__leaderboard_component__["a" /* LeaderboardComponent */], __WEBPACK_IMPORTED_MODULE_5__totalpoints_pipe__["a" /* TotalPointsPipe */]],
        exports: [__WEBPACK_IMPORTED_MODULE_4__leaderboard_component__["a" /* LeaderboardComponent */]]
    })
], LeaderboardModule);

//# sourceMappingURL=leaderboard.module.js.map

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaderboard\">\r\n  \r\n  <div *ngIf=\"!participants\">\r\n    <wd-spinner></wd-spinner> \r\n  </div>\r\n\r\n  <div *ngIf=\"participants\">\r\n\r\n    <div class=\"text-center\">\r\n        <button *ngIf=\"state == 0\" class=\"btn btn-xs btn-info\" (click)=\"state = 1\">\r\n            show individual leaderboard\r\n        </button>\r\n        <button *ngIf=\"state == 1\" class=\"btn btn-xs btn-info\" (click)=\"state = 0\">\r\n            show group leaderboard\r\n        </button>\r\n    </div>\r\n\r\n    <div *ngIf=\"state == 0\">\r\n\r\n        <div *ngIf=\"!groups\">\r\n            <wd-spinner [subtitle]=\"'Loading groups'\"></wd-spinner> \r\n          </div>\r\n\r\n      <table class=\"table\">\r\n        <tr>\r\n          <th>Rank</th>\r\n          <th>Group</th>\r\n          <th>Size</th>\r\n          <th class=\"points\">Average</th>\r\n          <th class=\"points\">Total</th>\r\n        </tr>\r\n        <tr *ngFor=\"let item of groups;let i = index\" >\r\n          <td>#{{i + 1}}</td>\r\n          <td>{{item.groupName}}</td>\r\n          <td >{{item.members.length}} <span class=\"resp\">members</span></td>     \r\n          <td class=\"points\">{{item.points}} <span class=\"resp\">points</span></td>\r\n          <td class=\"points\">{{item.totalPoints}} <span class=\"resp\">points</span></td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n\r\n    <div *ngIf=\"state == 1\">\r\n      <table class=\"table\">\r\n        <tr>\r\n          <th>Rank</th>\r\n          <th>Name</th>\r\n          <th>Group</th>\r\n          <th class=\"points\">Points</th>\r\n        </tr>\r\n        <tr *ngFor=\"let item of leaderboard;let i = index\" [ngClass]=\"{ 'me' : user && item.email == (user | async)?.email }\">\r\n          <td>#{{i + 1}}</td>\r\n          <td>{{item.name ? item.name : item.email}}</td> \r\n          <td>{{item.group}}</td>\r\n          <td class=\"points\">{{item.points}} <span class=\"resp\">points</span></td>     \r\n        </tr>\r\n      </table>\r\n      <div class=\"text-center\">\r\n        <button *ngIf=\"leaderboard == top5\" class=\"btn btn-xs btn-info\" (click)=\"leaderboard = participants\">show all</button>\r\n        <button *ngIf=\"leaderboard == participants\" class=\"btn btn-xs btn-info\" (click)=\"leaderboard = top5\">show less</button>\r\n      </div>\r\n    </div>\r\n</div>\r\n</div>\r\n\r\n"

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".leaderboard{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);background-color:#fff;min-height:100px}.leaderboard table{border-collapse:collapse}.leaderboard table tr{border-bottom:1px solid #eee;position:relative}.leaderboard table tr.me{font-weight:700}.leaderboard .loader{height:3px;width:100%;background-color:orange;position:absolute;bottom:0;left:0}.table{margin-bottom:0}.points{text-align:right;padding-right:50px}th{font-weight:400;color:#888;font-style:italic;font-size:80%}@media (max-width:767px){.resp{display:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TotalPointsPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var TotalPointsPipe = (function () {
    function TotalPointsPipe() {
    }
    TotalPointsPipe.prototype.transform = function (items, filter) {
        var totalPoints = 0;
        items.forEach(function (item) { return totalPoints += item.points; });
        return totalPoints;
    };
    return TotalPointsPipe;
}());
TotalPointsPipe = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Pipe */])({
        name: 'wdtotalpoints',
        pure: false
    })
], TotalPointsPipe);

//# sourceMappingURL=totalpoints.pipe.js.map

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignmentComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_assignment_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_assignment__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_account_service__ = __webpack_require__(19);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var AssignmentComponent = (function () {
    function AssignmentComponent(accountService, dictaatService, assignmentService, configService) {
        this.accountService = accountService;
        this.dictaatService = dictaatService;
        this.assignmentService = assignmentService;
        this.configService = configService;
    }
    AssignmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configService.Config.subscribe(function (config) {
            _this.dictaatName = config ? config.name : null;
            if (_this.dictaatName)
                _this.assignmentService.getAssignmentDetails(config.name, _this.aid).then(function (ad) {
                    _this.assignment = ad;
                });
        });
        this.accountService.User.subscribe(function (user) { return _this.user = user; });
    };
    AssignmentComponent.prototype.submit = function () {
        var _this = this;
        this.assignment.state = 1;
        this.assignmentService.submit(this.dictaatName, this.aid, this.user.id)
            .then(function (s) { return _this.assignment.mySubmission = s; })
            .catch(function (s) { return _this.assignment.state = 0; });
    };
    AssignmentComponent.prototype.edit = function () {
        var _this = this;
        var original = Object.assign({}, this.assignment);
        this.assignmentService.ShowModal('edit', [this.assignment])
            .then(function (assignment) { return _this.assignment = assignment; })
            .catch(function () {
            _this.assignment = new __WEBPACK_IMPORTED_MODULE_2__models_assignment__["a" /* Assignment */](original);
        });
    };
    return AssignmentComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], AssignmentComponent.prototype, "aid", void 0);
AssignmentComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-assignment',
        template: __webpack_require__(494),
        styles: [__webpack_require__(495)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__services_account_service__["a" /* AccountService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__services_dictaat_service__["a" /* DictaatService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_dictaat_service__["a" /* DictaatService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__services_assignment_service__["a" /* AssignmentService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_assignment_service__["a" /* AssignmentService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__services_config_service__["a" /* ConfigService */]) === "function" && _d || Object])
], AssignmentComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=assignment.component.js.map

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports = "<div class=\"assignment\" *ngIf=\"assignment\" [ngClass]=\"'level-' + assignment.level\">\r\n  <h1>{{assignment.title}}</h1>\r\n  <p>\r\n    {{assignment.description}}\r\n  </p>\r\n  <div class=\"tooltip-container\">\r\n\r\n    <!-- Edit only visible in CMS -->\r\n    <span class=\"tooltip-item edit\" (click)=\"edit()\">\r\n      <span class=\"glyphicon glyphicon-pencil\"  aria-hidden=\"true\"></span>\r\n    </span>\r\n\r\n\r\n    <span class=\"tooltip-item none\" *ngIf=\"assignment.state == 0\" (click)=\"submit()\">\r\n        <span class=\"glyphicon glyphicon-share-alt\"  aria-hidden=\"true\"></span>\r\n    <span class=\"tooltip\">Mark this assignment as complete. You will recieve points when a teacher accepts this submission</span>\r\n    </span>\r\n    <span class=\"tooltip-item primary\" *ngIf=\"assignment.state == 1\">\r\n        <span class=\"glyphicon glyphicon-hourglass\"  aria-hidden=\"true\"></span>\r\n    <span class=\"tooltip\">This assignment is marked as complete. You will recieve points when a teacher accepts this submission</span>\r\n    </span>\r\n    <span class=\"tooltip-item success\" *ngIf=\"assignment.state == 2\">\r\n       <span class=\"glyphicon glyphicon-ok\"  aria-hidden=\"true\"></span>\r\n    <span class=\"tooltip\">yay! This assignment was completed on {{assignment.mySubmission.timestamp | date}}</span>\r\n    </span>\r\n\r\n    <span class=\"tooltip-item points\">\r\n      <span>{{assignment.points}}</span>\r\n    </span>\r\n\r\n  </div>\r\n</div>\r\n\r\n<div class=\"assignment\" *ngIf=\"!assignment\">\r\n  <wd-spinner></wd-spinner>\r\n</div>"

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".assignment{padding:15px;position:relative;background-color:#fff}.assignment h1{margin-top:5px}.assignment.level-Gold{border-bottom:2px solid gold}.assignment.level-Gold .points{color:#fff;background-color:gold}.assignment.level-Bronze{border-bottom:2px solid #cd7f32},.assignment.level-Bronze .points{color:#fff;background-color:#cd7f32}.assignment.level-Silver{border-bottom:2px solid silver}.assignment.level-Silver .points{color:#fff;background-color:silver}.tooltip-container .none{color:#000;font-size:1em;background-color:#eee;cursor:pointer}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PortalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_participantService__ = __webpack_require__(92);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var PortalComponent = (function () {
    function PortalComponent(participantService, accountService, configService) {
        this.participantService = participantService;
        this.accountService = accountService;
        this.configService = configService;
    }
    PortalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.User.subscribe(function (user) { _this.user = user; _this.retrieveParticipant(); });
        this.configService.Config.subscribe(function (config) { _this.config = config; _this.retrieveParticipant(); });
    };
    PortalComponent.prototype.retrieveParticipant = function () {
        var _this = this;
        if (this.config && this.user && !this.portal) {
            this.participantService.getParticipant(this.config.name, this.user.email)
                .then(function (participant) {
                _this.portal = participant;
            });
        }
    };
    PortalComponent.prototype.onError = function () {
    };
    return PortalComponent;
}());
PortalComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-portal',
        template: __webpack_require__(497),
        styles: [__webpack_require__(498)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_3__services_participantService__["a" /* ParticipantService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_participantService__["a" /* ParticipantService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */]) === "function" && _c || Object])
], PortalComponent);

var _a, _b, _c;
//# sourceMappingURL=portal.component.js.map

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"!portal  && user\" class=\"spinner\">\r\n    <wd-spinner></wd-spinner> \r\n  </div>\r\n\r\n<div class=\"portal\" *ngIf=\"portal\">\r\n  \r\n    <div class=\"element\">\r\n        <p>You completed <span class=\"focus\">{{portal.completedAssignments}} out of {{portal.assignmentIds.length}}</span> \r\n            assignments for this course.\r\n        </p>\r\n    </div>\r\n    <div class=\"gap\"></div>\r\n    <div class=\"element\">\r\n        <p>You recieved<span class=\"focus\">{{portal.recievedPoints}} points </span>in this course</p>\r\n    </div>\r\n    <div class=\"gap\"></div>\r\n    <div class=\"element\">\r\n        <span class=\"glyphicons glyphicons-family\"></span>\r\n        <p *ngIf=\"portal.completedAssignments > 0\">\r\n            You are\r\n            <span class=\"focus\" *ngIf=\"portal.comparedToAverage > 0\">{{portal.comparedToAverage |  number : '1.2-2'}}% better</span>\r\n            <span class=\"focus\" *ngIf=\"portal.comparedToAverage < 0\">{{(portal.comparedToAverage * -1) |  number : '1.2-2'}}% behind</span> \r\n            compared to other participants\r\n        </p>   \r\n        <p *ngIf=\"portal.completedAssignments === 0\">\r\n            Go make <span class=\"focus\">your first</span> assignment!\r\n        </p>\r\n    </div>\r\n      \r\n</div>\r\n\r\n"

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".portal{min-height:100px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:5px 0}.portal,.portal .element{display:-webkit-box;display:-ms-flexbox;display:flex}.portal .element{border:1px dotted #888;border-radius:2px;padding:20px 30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-ms-flex-preferred-size:0;flex-basis:0}.portal .spinner{position:absolute}.portal .gap{-webkit-box-flex:1;-ms-flex:1 0 10px;flex:1 0 10px}.focus{display:block;font-weight:700}.portal .element p{text-align:center}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PollComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_poll_service__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_poll__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_account_service__ = __webpack_require__(19);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var PollComponent = (function () {
    function PollComponent(pollService, configService, accountService) {
        this.pollService = pollService;
        this.configService = configService;
        this.accountService = accountService;
        this.selectedOption = null;
        this.isSubmitting = false;
    }
    PollComponent.prototype.getColor = function (index) {
        if (this.poll) {
            //avans red = rgb(198, 0, 42);
            var value = (198 / this.poll.options.length + 1) * (index + 1);
            return "rgb(" + (value) + ",0, 42)";
        }
    };
    PollComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.User.subscribe(function (u) {
            _this.isAuth = u != null;
        });
        this.configService.DictaatName.subscribe(function (name) {
            if (name) {
                _this.dictaatName = name;
                _this.pollService.getPoll(name, _this.pid)
                    .then(function (poll) { return _this.poll = poll; });
            }
        });
    };
    PollComponent.prototype.isSelected = function (option) {
        return option == this.selectedOption;
    };
    PollComponent.prototype.vote = function () {
        var _this = this;
        if (!this.isSubmitting) {
            this.isSubmitting = true;
            this.pollService.vote(this.dictaatName, this.poll.id, this.selectedOption.id)
                .then(function (poll) {
                _this.poll = poll;
                _this.isSubmitting = false;
            });
        }
    };
    PollComponent.prototype.login = function () {
        this.accountService.Login();
    };
    PollComponent.prototype.edit = function () {
        var _this = this;
        var original = Object.assign({}, this.poll);
        this.pollService.ShowModal('edit', [this.poll])
            .then(function (poll) { return _this.poll = poll; })
            .catch(function () {
            _this.poll = new __WEBPACK_IMPORTED_MODULE_3__models_poll__["a" /* Poll */](original);
        });
    };
    return PollComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], PollComponent.prototype, "pid", void 0);
PollComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: 'wd-poll',
        template: __webpack_require__(500),
        styles: [__webpack_require__(501)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__services_poll_service__["a" /* PollService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_poll_service__["a" /* PollService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_config_service__["a" /* ConfigService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_4__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__services_account_service__["a" /* AccountService */]) === "function" && _c || Object])
], PollComponent);

var _a, _b, _c;
//# sourceMappingURL=poll.component.js.map

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports = "<div class=\"poll bs-callout  bs-callout-default\">\r\n\r\n  <div *ngIf=\"!poll\">\r\n    <wd-spinner [subtitle]=\"'Loading poll'\"></wd-spinner> \r\n  </div>\r\n\r\n\r\n\r\n  <div *ngIf=\"poll\" >\r\n\r\n    <header>\r\n        <h2>Poll - {{poll.question}}</h2>\r\n        <div class=\"tooltip-container\">\r\n\r\n            <!-- Edit only visible in CMS -->\r\n            <span class=\"tooltip-item edit\" (click)=\"edit()\">\r\n                <span class=\"glyphicon glyphicon-pencil\"  aria-hidden=\"true\"></span>\r\n            </span>\r\n\r\n        </div>\r\n    </header>\r\n\r\n    <div class=\"poll-container\"  *ngIf=\"!isSubmitting\">\r\n\r\n        <!-- NOT VOTED YET -->\r\n        <div *ngIf=\"!poll.myVote\">\r\n            <div *ngFor='let option of poll.options'>\r\n                <button class=\"btn btn-raised btn-default answer\" (click)=\"selectedOption = option;\"  \r\n                        [ngClass]=\"{'btn-info' : isSelected(option)}\">\r\n                        {{option.text}}\r\n                </button>\r\n            </div>\r\n\r\n            <div class=\"actions pull-right\">\r\n                \r\n                <button \r\n                    *ngIf=\"!isAuth\"\r\n                    class=\"btn btn-raised btn-primary next\" \r\n                    (click)=\"login()\" >\r\n                    Login to vote\r\n                </button>\r\n\r\n                <button \r\n                    *ngIf=\"isAuth\"\r\n                    class=\"btn btn-raised btn-primary next\" \r\n                    [disabled]=\"isSubmitting || !selectedOption\" \r\n                    (click)=\"vote()\" >\r\n                    VOTE\r\n                </button>\r\n\r\n            </div>\r\n        </div>\r\n\r\n        <!-- AFTER VOTING -->\r\n        <div *ngIf=\"poll.myVote\">\r\n\r\n            <div *ngFor='let option of poll.options; let i = index;' class=\"option\">\r\n                <span class=\"option-text\">{{option.text}}</span>\r\n                <div class=\"score animated\">\r\n                    <span class=\"beam\" [style.width.%]=\"option.votesPercentage\" [style.background]=\"getColor(i)\">\r\n                    </span>\r\n                    <span class=\"percentage\">{{option.votesPercentage}}%</span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"disclaimer pull-right\">\r\n                <p>*You already voted for this poll</p>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div *ngIf=\"isSubmitting\">\r\n        <wd-spinner [subtitle]=\"'Loading votes'\"></wd-spinner> \r\n    </div>\r\n        \r\n  </div>\r\n</div>"

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".beam{display:inline-block;height:20px;background-color:#2e2e2e;color:#fff;min-width:10px;-webkit-transform-origin:left center;transform-origin:left center;-webkit-animation:bounce-scale .7s ease-in-out}@-webkit-keyframes bounce-scale{0%{-webkit-transform:scalex(.01);transform:scalex(.01)}to{-webkit-transform:scalex(1);transform:scalex(1)}}@keyframes bounce-scale{0%{-webkit-transform:scalex(.01);transform:scalex(.01)}to{-webkit-transform:scalex(1);transform:scalex(1)}}.option{line-height:20px;margin-top:5px}.option-text{color:#2e2e2e}.percentage{padding:3px 5px}.poll{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);background-color:#fff;min-height:100px;padding:0}.poll-container{overflow:hidden;margin:20px}.disclaimer{color:#a9a9a9;font-style:italic}.score{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}header{padding:20px;margin:10px 0;border-bottom:1px solid #ddd;position:relative}h2{font-size:150%;margin:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatabComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datab_service__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_assignment_service__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_config_service__ = __webpack_require__(18);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var DatabComponent = (function () {
    function DatabComponent(databService, accountService, assignmentService, configService) {
        this.databService = databService;
        this.accountService = accountService;
        this.assignmentService = assignmentService;
        this.configService = configService;
        this.pollticker = 0;
    }
    DatabComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configService.Config.subscribe(function (config) {
            _this.dictaatName = config.name;
            _this.accountService.User.subscribe(function (user) {
                _this.assignmentService.getAssignmentDetails(_this.dictaatName, _this.waid).then(function (assignment) {
                    _this.assignment = assignment;
                    if (user) {
                        _this.user = user;
                        _this.getAssignment();
                        _this.getSubmission();
                    }
                });
            });
        });
    };
    DatabComponent.prototype.getAssignment = function () {
        var _this = this;
        this.databService.getAssignment(this.assignment.externalId)
            .subscribe(function (response) {
            if (response) {
                _this.expectedOutput = response.expectedOutput;
            }
        });
    };
    DatabComponent.prototype.getSubmission = function () {
        var _this = this;
        this.databService.getSubmissions(this.assignment.externalId, this.user.email)
            .subscribe(function (submission) {
            if (submission) {
                _this.submission = submission;
                _this.checkIfComplete();
            }
            else {
                _this.submission = new __WEBPACK_IMPORTED_MODULE_1__datab_service__["b" /* DbSubmission */]();
                _this.submission.email = _this.user.email;
            }
        });
    };
    DatabComponent.prototype.checkIfComplete = function () {
        var _this = this;
        if (this.submission.assignmentToken && !this.assignment.mySubmission) {
            this.assignmentService.submitWithToken(this.dictaatName, this.waid, this.submission.assignmentToken)
                .then(function (assignment) {
                _this.assignment = assignment;
            });
        }
    };
    DatabComponent.prototype.submit = function () {
        var _this = this;
        this.err = null; //reset err;
        this.submission.message = null;
        this.databService.sendSubmission(this.waid, this.assignment.externalId, this.submission)
            .subscribe(function (submission) {
            _this.submission = submission;
            //start polling for 10s
            _this.pollticker = 0;
            _this.poll();
        });
    };
    DatabComponent.prototype.poll = function () {
        var _this = this;
        this.databService.getSubmissions(this.assignment.externalId, this.user.email)
            .subscribe(function (submission) {
            _this.submission = submission;
            if (_this.submission && _this.submission.statusId != 0) {
                _this.checkIfComplete();
            }
            else if (_this.pollticker != 5) {
                //try agian in 2s
                setTimeout(function () {
                    _this.pollticker++;
                    _this.poll();
                }, 2000);
            }
        });
    };
    return DatabComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], DatabComponent.prototype, "waid", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Number)
], DatabComponent.prototype, "daid", void 0);
DatabComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-datab",
        styles: [__webpack_require__(504)],
        template: __webpack_require__(505)
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__datab_service__["a" /* DatabService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__datab_service__["a" /* DatabService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__shared_services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__shared_services_assignment_service__["a" /* AssignmentService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__shared_services_assignment_service__["a" /* AssignmentService */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__shared_services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__shared_services_config_service__["a" /* ConfigService */]) === "function" && _d || Object])
], DatabComponent);

var _a, _b, _c, _d;
//# sourceMappingURL=datab.component.js.map

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, "textarea{resize:vertical;width:100%}.title{font-weight:700}.datab{position:relative;padding:10px}.datab .loader{position:absolute;width:100%;height:100%;background-color:hsla(0,0%,39%,.3);top:0;left:0}.datab .loader .spinner{position:absolute;left:50%;top:50%;width:100px;margin-left:-50px;margin-top:-30px}.assignment{padding:15px;position:relative;background-color:#fff}.assignment h1{margin-top:5px}.points{width:50px;height:50px;background-color:#fff;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);border-radius:50%;position:absolute;bottom:-26px;right:16px;z-index:101}.assignment.level-Gold{border-bottom:2px solid gold}.assignment.level-Gold .points{background-color:gold}.assignment.level-Bronze{border-bottom:2px solid #cd7f32}.assignment.level-Bronze .points{background-color:#cd7f32}.assignment.level-Silver{border-bottom:2px solid silver}.assignment.level-Silver .points{background-color:silver}.assignment .points.complete{background-color:#5cb85c!important}.points span{color:#fff;font-weight:700;display:block;width:100%;text-align:center;line-height:50px;font-size:16px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports = "\r\n<div class=\"panel\">\r\n    <div class=\"assignment\" *ngIf=\"assignment\" [ngClass]=\"'level-' + assignment.level\">\r\n        <div class=\"title\">{{assignment.title}}</div>\r\n        <p>\r\n            {{assignment.description}}\r\n        </p>\r\n        <div>\r\n            <button *ngIf=\"!show\" class=\"btn btn-xs btn-info\" (click)=\"show = true\">show expected output</button>\r\n            <button *ngIf=\"show\" class=\"btn btn-xs btn-info\" (click)=\"show = false\">hide expected output</button>\r\n            <div [innerHTML]=\"expectedOutput\" *ngIf=\"show\"></div>\r\n        </div>\r\n        <div class=\"points tooltip-container\" [ngClass]=\"{'complete': assignment.mySubmission }\">\r\n            <span *ngIf=\"!assignment.mySubmission\">{{assignment.points}}</span>\r\n            <span *ngIf=\"assignment.mySubmission\" class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n        </div>\r\n        </div>\r\n\r\n        <div class=\"assignment\" *ngIf=\"!assignment\" >\r\n        <wd-spinner></wd-spinner>\r\n    </div>\r\n\r\n    <div class=\"datab\" *ngIf=\"submission\">\r\n       \r\n        <div>\r\n            <textarea [(ngModel)]=\"submission.query\" ></textarea>\r\n            <div>\r\n                <button class=\"btn btn-default btn-raised\" (click)=\"submit()\">Submit</button>\r\n            </div> \r\n        </div>\r\n        <div *ngIf=\"submission.statusId == 1\"> <!-- correct query -->\r\n            <div class=\"alert alert-dismissible alert-success\" *ngIf=\"!submission.hide\">\r\n                <button type=\"button\" class=\"close\" (click)=\"submission.hide = true\">×</button>\r\n                <strong>Well done!</strong> \r\n                <p>You completed this assignment on {{submission.timestamp | date:'shortDate'}}</p>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"submission.statusId >= 2 \" > <!-- Wrong query-->\r\n            <div class=\"alert alert-dismissible alert-warning\" *ngIf=\"submission.message\" >\r\n                <button type=\"button\" class=\"close\" (click)=\"submission.message = null\">×</button>\r\n                <strong>Oh snap!</strong> <p>{{submission.message}}. </p>\r\n                <p>Change a few things up and try submitting again.</p>\r\n                \r\n            </div>\r\n        </div>\r\n        <div class=\"alert alert-dismissible alert-danger\" *ngIf=\"err\" >\r\n            <button type=\"button\" class=\"close\" (click)=\"err = null\">×</button>\r\n            <strong>Oh noes! :(</strong> <p>{{err}}. </p>\r\n            <p>Please wait a few minutes before submitting again. Our poor servers need some time to recover.</p>\r\n            \r\n        </div>\r\n        <div class=\"loader\" *ngIf=\"submission.statusId == 0\">\r\n            <wd-spinner class=\"spinner\"></wd-spinner>\r\n        </div>\r\n    </div>\r\n     \r\n     <div class=\"datab\" *ngIf=\"!submission && user\">\r\n        Loading submission\r\n     </div>\r\n\r\n     <div class=\"datab text-center\" *ngIf=\"!user\">\r\n        Login to submit your answer!\r\n     </div>\r\n</div>\r\n"

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_menu_service__ = __webpack_require__(280);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var NavMenuComponent = (function () {
    function NavMenuComponent(route, navMenuService) {
        this.route = route;
        this.navMenuService = navMenuService;
    }
    NavMenuComponent.prototype.toggle = function (item) {
        if (this.selected == item) {
            this.selected = null;
        }
        else {
            this.selected = item;
        }
    };
    NavMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.MenuItems) {
            this.navMenuService.getLocalNavMenu().then(function (menuItems) {
                _this.MenuItems = menuItems;
            });
        }
    };
    return NavMenuComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Array)
], NavMenuComponent.prototype, "MenuItems", void 0);
NavMenuComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-nav-menu",
        template: __webpack_require__(507),
        styles: [__webpack_require__(508)],
        providers: [__WEBPACK_IMPORTED_MODULE_2__nav_menu_service__["a" /* NavMenuService */]]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* ActivatedRoute */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__nav_menu_service__["a" /* NavMenuService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__nav_menu_service__["a" /* NavMenuService */]) === "function" && _b || Object])
], NavMenuComponent);

var _a, _b;
//# sourceMappingURL=nav-menu.component.js.map

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav root\" *ngIf=\"MenuItems\">\r\n\r\n    <li *ngFor=\"let item of MenuItems\">\r\n\r\n        <!-- menu item -->\r\n        <a routerLink=\"{{item.Url}}\" routerLinkActive=\"active\" *ngIf=\"item.Url && !item.IsDisabled\">\r\n            {{item.Name}}\r\n        </a>\r\n\r\n        <!-- sub menu -->\r\n        <a  (click)=\"toggle(item)\" [ngClass]=\"{'rotate': item == selected}\" class=\"dropdown-toggle\" \r\n            *ngIf=\"!item.Url && !item.IsDisabled\">\r\n            <span>{{item.Name}}</span>\r\n            <span class=\"caret\"></span>\r\n        </a>\r\n\r\n        <ol class=\"nav sub\" [ngClass]=\"{'open': item == selected}\">\r\n            <li *ngFor=\"let subItem of item.MenuItems\">\r\n                <!-- menu item -->\r\n                <a routerLink=\"{{subItem.Url}}\" *ngIf=\"!subItem.IsDisabled\" routerLinkActive=\"active\">\r\n                    {{subItem.Name}}\r\n                </a>\r\n            </li>\r\n        </ol>\r\n    </li>\r\n</ul>\r\n"

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".nav{background-color:#fff}.nav.root{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.dropdown-menu,.dropdown-menu li{display:block;width:100%}.dropdown-menu li:hover{background-color:#eee}a{border-left:5px solid #a9a9a9}a.active{border-left:5px solid #00aeed}.nav{max-height:80vh;overflow-y:auto}.nav.sub{max-height:0;overflow:hidden}.nav.sub a{font-size:90%;color:#000;text-decoration:underline}.nav.sub.open{transition:max-height .5s;max-height:1000px}.dropdown-toggle{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dropdown-toggle .caret{transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.dropdown-toggle.rotate .caret{-webkit-transform:rotate(180deg);transform:rotate(180deg)}@media (min-width:767px){.nav.root{margin:20px}}@media (max-width:767px){.nav.root{padding-bottom:50px;max-height:100%;overflow-y:auto;box-shadow:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_account_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_config_service__ = __webpack_require__(18);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AvatarComponent = (function () {
    function AvatarComponent(accountService, dictaatService, configService) {
        this.accountService = accountService;
        this.dictaatService = dictaatService;
        this.configService = configService;
        this.isRoute = false;
    }
    AvatarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountService.User.subscribe(function (user) {
            _this.user = user;
        });
    };
    AvatarComponent.prototype.Login = function () {
        this.accountService.Login();
    };
    AvatarComponent.prototype.Logout = function () {
        this.accountService.Logoff();
    };
    return AvatarComponent;
}());
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["F" /* Input */])(),
    __metadata("design:type", Boolean)
], AvatarComponent.prototype, "isRoute", void 0);
AvatarComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        selector: "wd-avatar",
        styles: ["\n    \n        .profilelink{color:white;}\n        div{ float:right;}\n        a{color:white;}\n    "],
        template: __webpack_require__(510),
        providers: []
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__services_account_service__["a" /* AccountService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__services_dictaat_service__["a" /* DictaatService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__services_dictaat_service__["a" /* DictaatService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__services_config_service__["a" /* ConfigService */]) === "function" && _c || Object])
], AvatarComponent);

var _a, _b, _c;
//# sourceMappingURL=avatar.component.js.map

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"user\">\r\n    <p *ngIf=\"!isRoute\" class=\"navbar-text\">{{user.name}}</p>\r\n    <button  *ngIf=\"isRoute\" class=\"btn btn-default navbar-btn profilelink\" routerLink=\"/profile\" >\r\n        {{user.name}}\r\n    </button>\r\n    <button class=\"btn btn-default navbar-btn\" (click)=\"Logout()\">Logout</button>\r\n</div>\r\n<div *ngIf=\"!user\">\r\n    <button class=\"btn btn-default navbar-btn\" (click)=\"Login()\">Login</button>\r\n</div>\r\n\r\n    "

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_account_service__ = __webpack_require__(19);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var MessageComponent = (function () {
    function MessageComponent(dictaatService, accountService, configService) {
        this.dictaatService = dictaatService;
        this.accountService = accountService;
        this.configService = configService;
        this.hide = true;
    }
    MessageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user = this.accountService.User;
        this.configService.Config.subscribe(function (config) {
            if (!config)
                return;
            _this.dictaatName = config.name;
            _this.dictaatService.getDictaatSession(config.name).subscribe(function (session) {
                _this.participantCount = session.participantIds.length;
                _this.dictaatService.getGroups(_this.dictaatName)
                    .then(function (groups) {
                    _this.groups = groups;
                    _this.groups.push({ groupName: "none" });
                    _this.hide = session.containsMe;
                });
            });
        });
    };
    MessageComponent.prototype.join = function () {
        var _this = this;
        this.dictaatService.join(this.dictaatName, this.group)
            .then(function (didJoin) { return _this.hide = true; });
    };
    MessageComponent.prototype.login = function () {
        this.accountService.Login();
    };
    return MessageComponent;
}());
MessageComponent = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* Component */])({
        animations: [
            Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_36" /* trigger */])('enterAnimation', [
                Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_35" /* transition */])(':enter', [
                    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* style */])({ transform: 'translateY(-100%)', opacity: 0 }),
                    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_21" /* animate */])('1000ms', Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* style */])({ transform: 'translateY(0)', opacity: 1 }))
                ]),
                Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_35" /* transition */])(':leave', [
                    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* style */])({ transform: 'translateY(0)', opacity: 1 }),
                    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_21" /* animate */])('1000ms', Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* style */])({ transform: 'translateY(-100%)', opacity: 0 }))
                ])
            ])
        ],
        selector: 'wd-message',
        template: __webpack_require__(512),
        styles: [__webpack_require__(513)]
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__["a" /* DictaatService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__shared_services_dictaat_service__["a" /* DictaatService */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_3__shared_services_account_service__["a" /* AccountService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__shared_services_account_service__["a" /* AccountService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__["a" /* ConfigService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__shared_services_config_service__["a" /* ConfigService */]) === "function" && _c || Object])
], MessageComponent);

var _a, _b, _c;
//# sourceMappingURL=message.component.js.map

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports = "<div class=\"message-container wd-content\" [hidden]=\"hide\" [@enterAnimation]>\r\n  <div class=\"panel\">\r\n    <div class=\"panel-body\">\r\n        <h1>Welcome!</h1>\r\n        <p>Do you want to contest with other participants and get the most comple experience? Login and join the course!</p>\r\n        \r\n\r\n        <div *ngIf=\"user | async\" class=\"tiny-form\" >\r\n          <label>Select a group:</label>\r\n          <select [(ngModel)]=\"group\" class=\"form-control alphabet\">          \r\n              <option *ngFor=\"let g of groups\" [ngValue]=\"g.groupName\">{{g.groupName}}</option>        \r\n          </select>\r\n          <button class=\"btn btn-md btn-raised btn-primary\" [disabled]=\"!group\" (click)=\"join()\">Join</button>\r\n        </div>\r\n\r\n        <button *ngIf=\"!(user | async)\" class=\"btn btn-md btn-raised btn-primary\" (click)=\"login()\">Login</button>\r\n    </div>\r\n    <div class=\"panel-side\">\r\n      <img src=\"https://webdictaat.aii.avans.nl/cms/img/wd-logo.png\">\r\n      <p *ngIf=\"participantCount > 0\">Join <b>{{participantCount}}</b> others in this course!</p>\r\n      <p *ngIf=\"participantCount == 0\">Be the first to join this course!</p>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)();
// imports


// module
exports.push([module.i, ".message-container{padding:10px}.message-container .panel{padding:5px;position:relative}.panel-body h1{margin:0;font-size:130%}.panel-body{padding-right:40%;text-align:center}.panel-side{position:absolute;right:0;top:0;height:100%;width:30%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#c6002a}.panel-side p{color:#fff;width:60%;text-align:center}.tiny-form{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tiny-form label{padding:3px}.alphabet{background-color:#00aeed;color:#fff;display:inline-block;text-align:center;width:auto;padding:2px 20px;margin-bottom:0}.panel-side img{position:absolute;width:70px;left:-35px;top:50%;margin-top:-35px;box-shadow:0 1px 6px 0 rgba(0,0,0,.12),0 1px 6px 0 rgba(0,0,0,.12);border-radius:50%}@media (max-width:767px){.panel-side{display:none}.panel-body{padding-right:15px}.panel{border-bottom:4px solid #c6002a}.tiny-form{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// The file contents for the current environment will overwrite these during build.
var environment = {
    production: false
};
//# sourceMappingURL=environment.js.map

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TextPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QuestionBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_quiz_question__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var Checker = (function () {
    function Checker() {
    }
    Checker.prototype.reset = function () {
        this.isChecking = false;
        this.canCheck = false;
    };
    return Checker;
}());

var TextPart = (function () {
    function TextPart(text, type) {
        if (text === void 0) { text = null; }
        if (type === void 0) { type = null; }
        this.text = text;
        this.type = type;
    }
    return TextPart;
}());

var QuestionBase = (function () {
    function QuestionBase() {
    }
    QuestionBase.prototype.getParts = function (text) {
        var epicregex = /(\[\[.*?\]\])/g;
        var response = [];
        text.split(epicregex).forEach(function (text, i) {
            var part = new TextPart();
            //check if empty or null
            if (text == null || text.trim(' ').length == 0)
                return;
            if (text.match(epicregex)) {
                part.type = 'blank';
                part.text = text.slice(2, text.length - 2);
            }
            else {
                part.type = 'text';
                part.text = text;
            }
            response.push(part);
        });
        return response;
    };
    //a shuffle method from stackoveflow: 
    //https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
    QuestionBase.prototype.shuffle = function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };
    return QuestionBase;
}());

__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["F" /* Input */])(),
    __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__models_quiz_question__["a" /* Question */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__models_quiz_question__["a" /* Question */]) === "function" && _a || Object)
], QuestionBase.prototype, "question", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["F" /* Input */])(),
    __metadata("design:type", Checker)
], QuestionBase.prototype, "checker", void 0);
__decorate([
    Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["F" /* Input */])(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Array)
], QuestionBase.prototype, "getParts", null);
var _a;
//# sourceMappingURL=question.base.js.map

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Assignment; });
var Assignment = (function () {
    function Assignment(json) {
        if (json === void 0) { json = null; }
        if (json) {
            this.id = json.id;
            this.title = json.title;
            this.description = json.description;
            this.points = json.points;
            this.metadata = json.metadata;
            this.mySubmission = json.mySubmission;
            this.level = json.level;
            this.externalId = json.externalId;
            this.submissions = json.submission;
            if (json.mySubmission) {
                this.state = json.mySubmission.accepted ? 2 : 1;
            }
            else {
                this.state = 0;
            }
        }
        else {
            this.level = 1;
        }
    }
    Assignment.prototype.isValid = function () {
        if (this.title && this.description) {
            return true;
        }
        else {
            return false;
        }
    };
    return Assignment;
}());

//# sourceMappingURL=assignment.js.map

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_wd_service__ = __webpack_require__(17);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ParticipantService = (function () {
    function ParticipantService(wdapi) {
        this.wdapi = wdapi;
    }
    ParticipantService.prototype.getParticipant = function (dictaatName, email) {
        return this.wdapi.get('/dictaten/' + dictaatName + '/participants/' + email)
            .toPromise()
            .then(function (response) { return response.json(); });
    };
    return ParticipantService;
}());
ParticipantService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], ParticipantService);

var _a;
//# sourceMappingURL=participantService.js.map

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameElementsModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rating_rating_component__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__achievements_achievements_component__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quiz_quiz_module__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__leaderboard_leaderboard_module__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__leaderboard_leaderboard_component__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quiz_quiz_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assignment_assignment_component__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__portal_portal_component__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wd_shared_module__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__poll_poll_component__ = __webpack_require__(499);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



//components


//modules








var GameElementsModule = (function () {
    function GameElementsModule() {
    }
    return GameElementsModule;
}());
GameElementsModule = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["M" /* NgModule */])({
        imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["a" /* FormsModule */], __WEBPACK_IMPORTED_MODULE_5__quiz_quiz_module__["a" /* QuizModule */], __WEBPACK_IMPORTED_MODULE_11__wd_shared_module__["a" /* WdSharedModule */], __WEBPACK_IMPORTED_MODULE_6__leaderboard_leaderboard_module__["a" /* LeaderboardModule */]],
        declarations: [__WEBPACK_IMPORTED_MODULE_3__rating_rating_component__["a" /* RatingComponent */], __WEBPACK_IMPORTED_MODULE_4__achievements_achievements_component__["a" /* AchievementsComponent */], __WEBPACK_IMPORTED_MODULE_9__assignment_assignment_component__["a" /* AssignmentComponent */], __WEBPACK_IMPORTED_MODULE_10__portal_portal_component__["a" /* PortalComponent */], __WEBPACK_IMPORTED_MODULE_12__poll_poll_component__["a" /* PollComponent */]],
        exports: [__WEBPACK_IMPORTED_MODULE_3__rating_rating_component__["a" /* RatingComponent */], __WEBPACK_IMPORTED_MODULE_4__achievements_achievements_component__["a" /* AchievementsComponent */], __WEBPACK_IMPORTED_MODULE_7__leaderboard_leaderboard_component__["a" /* LeaderboardComponent */], __WEBPACK_IMPORTED_MODULE_12__poll_poll_component__["a" /* PollComponent */],
            __WEBPACK_IMPORTED_MODULE_8__quiz_quiz_component__["a" /* QuizComponent */], __WEBPACK_IMPORTED_MODULE_9__assignment_assignment_component__["a" /* AssignmentComponent */], __WEBPACK_IMPORTED_MODULE_10__portal_portal_component__["a" /* PortalComponent */],]
    })
], GameElementsModule);

//# sourceMappingURL=game-elements.module.js.map

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Question; });
var Question = (function () {
    function Question(json) {
        if (json === void 0) { json = null; }
        this.body = {};
        if (json) {
            this.id = json.id;
            this.text = json.text;
            this.type = json.type;
            this.body = json.body ? json.body : {};
            this.explanation = json.explanation;
            this.isCorrect = json.isCorrect;
        }
        this.original = JSON.stringify(this);
    }
    Question.prototype.isValid = function () {
        return this.text != null && this.type != null;
    };
    return Question;
}());

//# sourceMappingURL=question.js.map

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignmentService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_wd_service__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_assignment__ = __webpack_require__(67);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var AssignmentService = (function (_super) {
    __extends(AssignmentService, _super);
    function AssignmentService(wdapi) {
        var _this = _super.call(this) || this;
        _this.wdapi = wdapi;
        return _this;
    }
    AssignmentService.prototype.getAssignments = function (dictaatName) {
        var url = "/dictaten/" + dictaatName + '/assignment';
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AssignmentService.prototype.getAssignmentDetails = function (dictaatName, assignmentId) {
        var url = "/dictaten/" + dictaatName + '/assignment/' + assignmentId;
        return this.wdapi.get(url)
            .toPromise()
            .then(function (response) {
            return new __WEBPACK_IMPORTED_MODULE_5__models_assignment__["a" /* Assignment */](response.json());
        });
    };
    AssignmentService.prototype.addAssignment = function (dictaatName, assignment) {
        var url = "/dictaten/" + dictaatName + '/assignment';
        return this.wdapi.post(url, assignment)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AssignmentService.prototype.update = function (dictaatName, assignment) {
        var url = "/dictaten/" + dictaatName + '/assignment/' + assignment.id;
        return this.wdapi.put(url, assignment)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AssignmentService.prototype.delete = function (dictaatName, assignment) {
        var url = "/dictaten/" + dictaatName + '/assignment/' + assignment.id;
        return this.wdapi.delete(url)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    AssignmentService.prototype.submit = function (dictaatName, assignmentId, userId) {
        var url = "/dictaten/" + dictaatName + "/assignment/" + assignmentId + "/submissions";
        return this.wdapi.post(url, { userId: userId })
            .map(function (response) { return response.json(); })
            .toPromise();
    };
    //with token
    AssignmentService.prototype.submitWithToken = function (dictaatName, assignmentId, token) {
        return this.wdapi.post("/dictaten/" + dictaatName + "/assignment/" + assignmentId + "/submissions", { token: token })
            .map(function (response) { return response.json(); })
            .toPromise();
    };
    AssignmentService.prototype.unsubmit = function (dictaatName, assignmentId, userId) {
        var url = "/dictaten/" + dictaatName + "/assignment/" + assignmentId + "/submissions/" + userId;
        return this.wdapi.delete(url)
            .map(function (response) { return response.json(); })
            .toPromise()
            .then(function (response) {
            console.log(response);
        });
    };
    return AssignmentService;
}(__WEBPACK_IMPORTED_MODULE_2__core_basemodal_service__["a" /* BaseModalService */]));
AssignmentService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["C" /* Injectable */])(),
    __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__core_wd_service__["a" /* wdApi */]) === "function" && _a || Object])
], AssignmentService);

var _a;
//# sourceMappingURL=assignment.service.js.map

/***/ })

},[298]);


// WEBPACK FOOTER //
// main.bundle.js